var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-20",
    d: "M81,439.55c-93.33-53.88-93.33-141.24,0-195.12s244.65-53.89,338,0,93.33,141.24,0,195.12S174.34,493.44,81,439.55Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-20",
    d: "M290.7,443.57a3.59,3.59,0,0,1-3.49-2.89l-.83-4.38a48.23,48.23,0,0,1-5.66-1.39L273,438.49a4.23,4.23,0,0,1-1.76.37,4.36,4.36,0,0,1-2.14-.54l-7.62-4.4a3,3,0,0,1-.26-5.06l4.67-3.36a16.67,16.67,0,0,1-1.2-1.81l-9.75-.62a3.42,3.42,0,0,1-3.2-3.41V414a3.42,3.42,0,0,1,3.2-3.41l9.75-.62a16.78,16.78,0,0,1,1.2-1.82l-4.67-3.35a3,3,0,0,1,.26-5.06l7.62-4.4a4.36,4.36,0,0,1,2.14-.54,4,4,0,0,1,1.75.37l7.78,3.57a47.9,47.9,0,0,1,5.61-1.38l.83-4.39a3.59,3.59,0,0,1,3.49-2.88h11.21a3.59,3.59,0,0,1,3.48,2.89l.83,4.38a49.23,49.23,0,0,1,5.66,1.39l7.73-3.59a4.18,4.18,0,0,1,1.75-.36,4.36,4.36,0,0,1,2.14.54l7.63,4.4a3,3,0,0,1,.25,5.06l-4.67,3.35a17.81,17.81,0,0,1,1.2,1.82l9.75.62a3.42,3.42,0,0,1,3.2,3.41v5.66a3.42,3.42,0,0,1-3.2,3.41l-9.75.62a18.28,18.28,0,0,1-1.2,1.81l4.67,3.36a3,3,0,0,1-.26,5.06l-7.62,4.4a4.36,4.36,0,0,1-2.14.54,4.23,4.23,0,0,1-1.76-.37l-7.77-3.57a47.9,47.9,0,0,1-5.61,1.38l-.83,4.38a3.59,3.59,0,0,1-3.48,2.89Zm-6.08-32.1c-2.63,1.52-4.14,3.47-4.14,5.36s1.51,3.84,4.14,5.36a26.09,26.09,0,0,0,23.36,0c2.63-1.52,4.14-3.47,4.14-5.36s-1.51-3.84-4.14-5.36a26.09,26.09,0,0,0-23.36,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-20",
    d: "M224.05,462.59l-7.16-.75a3.78,3.78,0,0,1-3.36-4.21l.22-1.79c-.82-.27-1.61-.58-2.35-.9a2,2,0,0,0-.56-.06l-5.47,1.71a4.66,4.66,0,0,1-1.36.2,5.11,5.11,0,0,1-3.19-1.1l-3.59-3a3.29,3.29,0,0,1,.64-5.59l3.4-1.71s0-.1,0-.15l-5.68-1a3.6,3.6,0,0,1-2.86-4.67l1-3.11a4.32,4.32,0,0,1,4.15-2.93l6.32.26a.83.83,0,0,0,.27-.12c.19-.2.4-.4.61-.6l-1.5-1.6a3.33,3.33,0,0,1,1.21-5.49l5.63-2.25a4.61,4.61,0,0,1,1.77-.33,5.06,5.06,0,0,1,2.79.8l3.73,2.48a1.58,1.58,0,0,0,.47.1c1.24-.22,2.54-.38,3.72-.47l1.31-2.55a4.51,4.51,0,0,1,3.93-2.38h.28l7.16.75a3.76,3.76,0,0,1,3.36,4.21l-.22,1.78c.82.28,1.61.59,2.36.91a1.85,1.85,0,0,0,.56.06l5.46-1.71a4.39,4.39,0,0,1,1.36-.2,5.15,5.15,0,0,1,3.19,1.09l3.59,3a3.29,3.29,0,0,1-.64,5.6l-3.4,1.71c0,.05,0,.09,0,.14l5.68,1a3.6,3.6,0,0,1,2.86,4.68l-1,3.11a4.33,4.33,0,0,1-4.15,2.93l-6.31-.27a1.14,1.14,0,0,0-.27.12l-.62.61,1.51,1.6a3.34,3.34,0,0,1-1.22,5.49l-5.62,2.25a4.88,4.88,0,0,1-1.77.32,5.09,5.09,0,0,1-2.79-.79l-3.74-2.48a1.22,1.22,0,0,0-.47-.1c-1.24.22-2.54.38-3.72.47l-1.31,2.55a4.5,4.5,0,0,1-3.93,2.37ZM219.49,438c-2.35.94-3.94,2.36-4.15,3.7a3.25,3.25,0,0,0,1.46,2.77c2,1.69,5.64,2.74,9.41,2.74a18.12,18.12,0,0,0,6.7-1.2c2.35-.94,3.94-2.36,4.15-3.7a3.24,3.24,0,0,0-1.45-2.76c-2-1.7-5.65-2.75-9.42-2.75A18.33,18.33,0,0,0,219.49,438Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-20",
    d: "M459.29,381.28c14.06,8.09,14.06,21.21,0,29.3s-36.83,8.09-50.89,0-14-21.21,0-29.29S445.24,373.2,459.29,381.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-20",
    d: "M401.56,364c14.05,8.08,14.05,21.2,0,29.29s-36.84,8.09-50.89,0-14.06-21.21,0-29.29S387.5,355.88,401.56,364Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-20",
    d: "M72.94,417.26c12.59,7.25,12.59,19,0,26.25s-33,7.25-45.61,0-12.59-19,0-26.25S60.35,410,72.94,417.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-20",
    d: "M481.49,284.59a6.65,6.65,0,0,0-2.53-.79,3.71,3.71,0,0,0-2.16-2.94,11.57,11.57,0,0,0-10.47,0c-2.49,1.43-2.83,3.64-1,5.29a15.44,15.44,0,0,0-8.94,1.62,5.84,5.84,0,0,0-2.79,3c-4.5-1.31-10.13-.89-13.89,1.28a9,9,0,0,0-1.83,1.38h0a16.44,16.44,0,0,0-14.9,0,6,6,0,0,0-2.89,3.14,6.33,6.33,0,0,0-2.76-2.82c-3.53-2-8.93-2.32-13-.86a7.69,7.69,0,0,0-2.83-2.61c-3.71-2.14-9.24-2.58-13.72-1.33.86-1.88,0-3.95-2.51-5.42a15.21,15.21,0,0,0-9.67-1.42c1.36-1.57.91-3.53-1.36-4.83a11.38,11.38,0,0,0-10.29,0,4.43,4.43,0,0,0-1.85,1.82,7.3,7.3,0,0,0-4.5.72c-1.86,1.07-1.86,2.81,0,3.89a7.48,7.48,0,0,0,6.74,0l.26-.17a11.41,11.41,0,0,0,5.68.84c-2.53,2.19-2.13,5.17,1.21,7.1a15.31,15.31,0,0,0,10.28,1.29c-1.58,2.46-.67,5.33,2.76,7.31,4.32,2.49,11.12,2.68,15.83.57a7.15,7.15,0,0,0,2.06,1.7c3.85,2.23,9.93,2.37,14.07.43a2.9,2.9,0,0,0,.29.19,7.82,7.82,0,0,0,7.05,0,3.94,3.94,0,0,0,.45-.31c4.12,1.71,9.89,1.51,13.59-.63a9.25,9.25,0,0,0,1-.7c.25.18.52.35.81.52,4.69,2.71,12.29,2.71,17,0,2.15-1.24,3.3-2.84,3.48-4.47a15.81,15.81,0,0,0,10.56-1.37c3.76-2.16,3.95-5.61.58-7.91a12.48,12.48,0,0,0,2.29-.15,3.57,3.57,0,0,0,.86.67,7.84,7.84,0,0,0,7.06,0C483.43,287.54,483.43,285.71,481.49,284.59Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-20",
    d: "M97,51.16a10.42,10.42,0,0,1,3.44-.64c1.11-.08,1.46-.31,1.67-.55a8.2,8.2,0,0,1,9.84-2.9,6.28,6.28,0,0,1,7.42-4.19c-.13-3.46,4.29-7.18,8.25-8s7.12-.47,9.29,2c2.33-4.54,11.44-5.81,16.36-3.41,2.84,1.38,5.24,2.79,6.42,5.39A10.84,10.84,0,0,1,160.7,44c1.93-1.69,5.77-2.15,8.34-1.16,2.76,1.07,3,3.16,3.11,5.28a9.69,9.69,0,0,1,5-.09c1.75.52,2.75,1.88,2.51,3,1.38-.08,4.66,1,4.29,2.49-.43,1.64-4.18,1.47-5.58,1.42a24.84,24.84,0,0,1-3.92-.62,6.11,6.11,0,0,1-2,.39c-2.39,0-3.4-1-3.78-1.93-1.17,2.46-5.32,4.33-8.25,5.08-5.52,1.41-13.34.55-16.74-3.58a6.08,6.08,0,0,1-1.64,2,9.47,9.47,0,0,1-5.11,2.07c-2.27.22-8.35.51-10.07-3.1-1.21,2.4-6.63,3.49-10.75,2.91a16.9,16.9,0,0,1-4.61-1.4,25.26,25.26,0,0,1-2.66-1.59,2.21,2.21,0,0,0-2.26-.15c-2.82.85-6.11,1.2-9,0C95.28,54.06,94.79,52.14,97,51.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-20",
    d: "M404.54,52.25a11.3,11.3,0,0,1-7.57,0,1.86,1.86,0,0,0-1.9.13,23.92,23.92,0,0,1-2.23,1.34A14,14,0,0,1,389,54.9c-3.46.49-8-.42-9-2.44-1.45,3-6.57,2.79-8.47,2.61a8,8,0,0,1-4.3-1.74,5.06,5.06,0,0,1-1.39-1.69c-2.86,3.47-9.43,4.2-14.08,3-2.47-.63-6-2.21-6.94-4.27-.32.75-1.17,1.61-3.18,1.62a5,5,0,0,1-1.72-.32,21.19,21.19,0,0,1-3.3.51c-1.18.05-4.33.19-4.69-1.19-.32-1.22,2.45-2.16,3.61-2.1-.2-.93.64-2.08,2.11-2.51a8,8,0,0,1,4.23.08c.12-1.79.3-3.54,2.62-4.44,2.16-.84,5.4-.45,7,1a9.22,9.22,0,0,1,.9-4.34c1-2.19,3-3.38,5.4-4.54,4.14-2,11.81-.95,13.76,2.87,1.83-2.1,4.62-2.39,7.82-1.71s7.05,3.84,6.95,6.75a5.28,5.28,0,0,1,6.24,3.53A6.88,6.88,0,0,1,400.76,48c.18.2.48.39,1.42.46a8.72,8.72,0,0,1,2.88.54C406.88,49.82,406.48,51.44,404.54,52.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-20",
    d: "M189.47,65.63a7.47,7.47,0,0,1,2.47-.46c.8-.06,1.05-.22,1.21-.39a5.88,5.88,0,0,1,7.07-2.09,4.52,4.52,0,0,1,5.33-3c-.08-2.49,3.09-5.16,5.94-5.76s5.12-.34,6.69,1.46c1.67-3.27,8.22-4.19,11.76-2.46,2,1,3.77,2,4.61,3.88a7.74,7.74,0,0,1,.77,3.71,6.57,6.57,0,0,1,6-.83c2,.77,2.14,2.27,2.24,3.79a6.91,6.91,0,0,1,3.62-.06c1.26.37,2,1.35,1.81,2.15,1-.06,3.35.75,3.08,1.79s-3,1.06-4,1a18.26,18.26,0,0,1-2.82-.44,4.63,4.63,0,0,1-1.47.28c-1.72,0-2.44-.75-2.72-1.39-.84,1.76-3.82,3.11-5.93,3.65-4,1-9.59.4-12-2.57a4.34,4.34,0,0,1-1.18,1.44,6.86,6.86,0,0,1-3.67,1.49c-1.64.15-6,.36-7.25-2.23-.87,1.72-4.77,2.51-7.73,2.08a12,12,0,0,1-3.32-1,20.31,20.31,0,0,1-1.9-1.14,1.59,1.59,0,0,0-1.63-.11,9.71,9.71,0,0,1-6.47,0C188.26,67.72,187.92,66.33,189.47,65.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-20",
    d: "M485,67.63a5.36,5.36,0,0,0-1.77-.32c-.57,0-.75-.16-.86-.29a4.24,4.24,0,0,0-5.08-1.5,3.24,3.24,0,0,0-3.82-2.16c.06-1.78-2.22-3.7-4.27-4.13s-3.67-.25-4.79,1c-1.2-2.34-5.89-3-8.44-1.76a6.23,6.23,0,0,0-3.31,2.78,5.66,5.66,0,0,0-.55,2.67,4.69,4.69,0,0,0-4.29-.6c-1.43.55-1.54,1.63-1.61,2.72a5,5,0,0,0-2.6,0c-.9.26-1.41,1-1.29,1.54-.71,0-2.41.53-2.21,1.28s2.15.76,2.87.73a13.9,13.9,0,0,0,2-.31,3.32,3.32,0,0,0,1,.2c1.23,0,1.75-.54,2-1,.6,1.27,2.74,2.23,4.26,2.62,2.84.73,6.87.28,8.63-1.84a3.17,3.17,0,0,0,.85,1,5,5,0,0,0,2.63,1.07c1.17.11,4.31.26,5.2-1.6.62,1.23,3.42,1.8,5.54,1.49a8.53,8.53,0,0,0,2.38-.71c.56-.27.88-.53,1.37-.82a1.12,1.12,0,0,1,1.17-.08,6.91,6.91,0,0,0,4.64,0C485.9,69.13,486.15,68.14,485,67.63Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.52,
    cy: 285.08,
    rx: 29.05,
    ry: 11.91,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.52,
    cy: 285.08,
    rx: 29.05,
    ry: 11.91,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,277.13a12.91,12.91,0,0,1,25.81,0c0,.12,0,.23,0,.36s0,.23,0,.36c-.15,1.78-1.41,3.54-3.78,4.91-5,2.91-13.22,2.91-18.26,0-2.36-1.37-3.62-3.13-3.77-4.91,0-.13,0-.24,0-.36S389,277.25,389,277.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,265.86h0a12.89,12.89,0,0,1,18.51,11.27c0,.12,0,.23,0,.36s0,.23,0,.36c-.15,1.78-1.41,3.54-3.78,4.91a17.29,17.29,0,0,1-6.48,2c3.35-.58,5.52-4.32,4.49-8.45C407.85,271.55,403,264.62,396.3,265.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,277.85c0-.13,0-.24,0-.36s0-.24,0-.36a12.87,12.87,0,0,1,4.38-9.33c-1.4,1.44-4.52,6.88-1.13,11,2.23,2.72,12.81,6.61,21.52,1.61a8.83,8.83,0,0,1-2.74,2.33c-5,2.91-13.22,2.91-18.26,0C390.41,281.39,389.15,279.63,389,277.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402,267.48c-.58,1.32.53,3.08,2.48,3.93s4,.49,4.57-.83-.54-3.08-2.48-3.93S402.61,266.17,402,267.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.51,272.84a1.54,1.54,0,0,0,1,1.91,1.38,1.38,0,1,0-1-1.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.83,277.47a11,11,0,0,0-21.91,0c0,.11,0,.2,0,.31s0,.2,0,.3c.12,1.52,1.19,3,3.2,4.17a17.1,17.1,0,0,0,15.51,0c2-1.16,3.08-2.65,3.2-4.17,0-.1,0-.2,0-.3S443.84,277.58,443.83,277.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.63,267.91h0a10.93,10.93,0,0,0-15.71,9.56c0,.11,0,.2,0,.31s0,.2,0,.3c.12,1.52,1.19,3,3.2,4.17a14.49,14.49,0,0,0,5.5,1.72c-2.84-.49-4.68-3.66-3.81-7.17C427.83,272.73,431.94,266.85,437.63,267.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.83,278.08c0-.1,0-.2,0-.3s0-.2,0-.31a10.91,10.91,0,0,0-3.72-7.92c1.19,1.23,3.84,5.84,1,9.36-1.89,2.31-10.88,5.61-18.27,1.37a7.44,7.44,0,0,0,2.32,2,17.1,17.1,0,0,0,15.51,0C442.64,281.09,443.71,279.6,443.83,278.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.76,269.28c.49,1.12-.45,2.61-2.1,3.34s-3.4.41-3.89-.71.46-2.61,2.11-3.34S432.27,268.16,432.76,269.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.41,273.83a1.44,1.44,0,1,1-1.75-.49A1.29,1.29,0,0,1,426.41,273.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.84,279.45a7.25,7.25,0,0,0-14.49,0,1.41,1.41,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.69,3.69,0,0,0,2.12,2.75,11.29,11.29,0,0,0,10.25,0,3.72,3.72,0,0,0,2.12-2.75v-.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.74,273.13h0a7.23,7.23,0,0,0-10.39,6.32,1.41,1.41,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.69,3.69,0,0,0,2.12,2.75,9.55,9.55,0,0,0,3.63,1.14c-1.88-.33-3.09-2.42-2.52-4.74C444.25,276.32,447,272.43,450.74,273.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.84,279.86v-.41a7.25,7.25,0,0,0-2.46-5.24c.78.81,2.54,3.87.63,6.19-1.25,1.53-7.19,3.72-12.08.91a4.84,4.84,0,0,0,1.54,1.3,11.29,11.29,0,0,0,10.25,0A3.72,3.72,0,0,0,454.84,279.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.52,274c.32.74-.3,1.72-1.39,2.2s-2.25.27-2.57-.46.3-1.73,1.39-2.21S447.19,273.3,447.52,274Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.32,277a1,1,0,1,1-1.16-.32A.87.87,0,0,1,443.32,277Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.29,282.58a9.85,9.85,0,0,0-19.69,0,2.44,2.44,0,0,0,0,.27,2.62,2.62,0,0,0,0,.28c.11,1.36,1.07,2.7,2.88,3.75a15.42,15.42,0,0,0,13.94,0c1.8-1.05,2.76-2.39,2.87-3.75a2.62,2.62,0,0,0,0-.28A2.44,2.44,0,0,0,467.29,282.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72,274h0a9.84,9.84,0,0,0-14.12,8.6,2.44,2.44,0,0,0,0,.27,2.62,2.62,0,0,0,0,.28c.11,1.36,1.07,2.7,2.88,3.75a13.2,13.2,0,0,0,4.94,1.54c-2.55-.44-4.2-3.3-3.42-6.45C452.91,278.32,456.61,273,461.72,274Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.29,283.13a2.62,2.62,0,0,0,0-.28,2.44,2.44,0,0,0,0-.27,9.78,9.78,0,0,0-3.34-7.12c1.07,1.1,3.45,5.25.86,8.41-1.7,2.08-9.77,5-16.42,1.23a7,7,0,0,0,2.09,1.78,15.42,15.42,0,0,0,13.94,0C466.22,285.83,467.18,284.49,467.29,283.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.35,275.22c.44,1-.41,2.34-1.89,3s-3,.36-3.49-.64.4-2.35,1.89-3S456.91,274.21,457.35,275.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.64,279.3a1.29,1.29,0,1,1-1.58-.43A1.17,1.17,0,0,1,451.64,279.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.17,221.41a15.38,15.38,0,0,1-5.43,11.74,10,10,0,0,0-3.65,7.63v53.4a3.14,3.14,0,0,1-1.85,2.59,8.07,8.07,0,0,1-2.33.85,10.74,10.74,0,0,1-4.3,0,8.19,8.19,0,0,1-2.32-.85,3.16,3.16,0,0,1-1.85-2.59V240.71a9.94,9.94,0,0,0-3.63-7.55,15.29,15.29,0,0,1-5.45-11.87,15.41,15.41,0,0,1,30.81.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.36,221.41a8.59,8.59,0,0,1-3.63,7,7,7,0,0,0-2.82,5.71v61a2.17,2.17,0,0,1-2.13,2.2h0a2.17,2.17,0,0,1-2.13-2.2V234a6.88,6.88,0,0,0-2.82-5.61,8.58,8.58,0,0,1-3.62-7.24,8.6,8.6,0,0,1,17.19.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.31,228.78a3.26,3.26,0,1,1,3.26,3.26A3.26,3.26,0,0,1,423.31,228.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,219.11a2.46,2.46,0,1,1,2.45,2.46A2.45,2.45,0,0,1,422.74,219.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,215.2a1.22,1.22,0,1,1,1.21,1.21A1.21,1.21,0,0,1,418.05,215.2Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.33,216.66a3.3,3.3,0,1,1,3.3,3.3A3.3,3.3,0,0,1,408.33,216.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.78,222.62a1.55,1.55,0,1,0,1.55-1.55A1.55,1.55,0,0,0,407.78,222.62Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,228.53a3,3,0,1,1,3,3A3,3,0,0,1,408,228.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42,232.92a2.07,2.07,0,1,1,2.07,2.07A2.07,2.07,0,0,1,415.42,232.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.85,219.11a1.06,1.06,0,0,1,2.11,0,1.06,1.06,0,1,1-2.11,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.19,
    cy: 214.75,
    r: 1.39,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.18,221.57a1.4,1.4,0,1,1,1.4,1.39A1.4,1.4,0,0,1,429.18,221.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.09,223a1.4,1.4,0,1,1,1.4,1.4A1.4,1.4,0,0,1,416.09,223Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.57,282.6a6,6,0,0,0-12,0v.34a3.09,3.09,0,0,0,1.76,2.28,9.34,9.34,0,0,0,8.49,0,3.09,3.09,0,0,0,1.76-2.28v-.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.17,277.36h0a6,6,0,0,0-8.61,5.24v.34a3.09,3.09,0,0,0,1.76,2.28,7.88,7.88,0,0,0,3,.94c-1.56-.27-2.56-2-2.08-3.92C468.8,280,471.05,276.79,474.17,277.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.57,282.94v-.34a6,6,0,0,0-2-4.33c.65.67,2.1,3.19.52,5.12-1,1.27-5.95,3.08-10,.75a4.08,4.08,0,0,0,1.27,1.08,9.34,9.34,0,0,0,8.49,0A3.09,3.09,0,0,0,477.57,282.94Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.5,278.12c.27.61-.24,1.43-1.15,1.83s-1.86.22-2.13-.39.25-1.43,1.16-1.83S471.23,277.51,471.5,278.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468,280.61a.79.79,0,1,1-1-.27A.72.72,0,0,1,468,280.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.8,290.77a8.27,8.27,0,0,0-16.53,0,2.65,2.65,0,0,0,0,.46,4.23,4.23,0,0,0,2.42,3.14,12.9,12.9,0,0,0,11.7,0,4.26,4.26,0,0,0,2.41-3.14v-.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.12,283.55h0a8.26,8.26,0,0,0-11.85,7.22,2.65,2.65,0,0,0,0,.46,4.23,4.23,0,0,0,2.42,3.14,11.11,11.11,0,0,0,4.15,1.3c-2.15-.37-3.54-2.77-2.88-5.41C459.73,287.19,462.83,282.76,467.12,283.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.8,291.23v-.46a8.22,8.22,0,0,0-2.81-6c.9.93,2.9,4.41.73,7.06-1.43,1.74-8.21,4.24-13.79,1a5.89,5.89,0,0,0,1.76,1.48,12.9,12.9,0,0,0,11.7,0A4.26,4.26,0,0,0,471.8,291.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.45,284.59c.37.84-.34,2-1.59,2.52s-2.56.31-2.93-.54.34-2,1.59-2.51S463.08,283.75,463.45,284.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.66,288a1.09,1.09,0,0,1-2,.86,1.09,1.09,0,0,1,2-.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.41,295.12a10.26,10.26,0,0,0-20.51,0,2.81,2.81,0,0,0,0,.29,2.53,2.53,0,0,0,0,.28c.11,1.42,1.11,2.82,3,3.91a16.08,16.08,0,0,0,14.52,0c1.87-1.09,2.87-2.49,3-3.91a2.53,2.53,0,0,0,0-.28A2.81,2.81,0,0,0,458.41,295.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.61,286.17h0a10.24,10.24,0,0,0-14.71,8.95,2.81,2.81,0,0,0,0,.29,2.53,2.53,0,0,0,0,.28c.11,1.42,1.11,2.82,3,3.91a13.59,13.59,0,0,0,5.15,1.6c-2.66-.45-4.39-3.43-3.57-6.71C443.43,290.69,447.28,285.18,452.61,286.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.41,295.69a2.53,2.53,0,0,0,0-.28,2.81,2.81,0,0,0,0-.29,10.22,10.22,0,0,0-3.48-7.41c1.11,1.14,3.59,5.46.9,8.76-1.77,2.16-10.19,5.25-17.11,1.28a7.16,7.16,0,0,0,2.18,1.85,16.08,16.08,0,0,0,14.52,0C457.29,298.51,458.29,297.11,458.41,295.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.05,287.46c.46,1-.42,2.44-2,3.12s-3.18.38-3.64-.66.43-2.45,2-3.13S447.59,286.41,448.05,287.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.11,291.71a1.35,1.35,0,1,1-1.65-.45A1.22,1.22,0,0,1,442.11,291.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,286.15a3.63,3.63,0,0,0-7.25,0v.21a1.86,1.86,0,0,0,1.06,1.38,5.72,5.72,0,0,0,5.13,0,1.86,1.86,0,0,0,1.06-1.38.41.41,0,0,0,0-.11A.38.38,0,0,0,481.39,286.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,286.15a3.63,3.63,0,0,0-7.25,0v.21a1.86,1.86,0,0,0,1.06,1.38,5.72,5.72,0,0,0,5.13,0,1.86,1.86,0,0,0,1.06-1.38.41.41,0,0,0,0-.11A.38.38,0,0,0,481.39,286.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.34,283h0a3.63,3.63,0,0,0-5.2,3.16v.21a1.86,1.86,0,0,0,1.06,1.38,4.79,4.79,0,0,0,1.82.56,1.83,1.83,0,0,1-1.26-2.37C476.1,284.59,477.46,282.64,479.34,283Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.39,286.36a.41.41,0,0,0,0-.11.38.38,0,0,0,0-.1,3.61,3.61,0,0,0-1.23-2.62c.4.41,1.27,1.93.32,3.1a5.58,5.58,0,0,1-6.05.45,2.56,2.56,0,0,0,.77.66,5.72,5.72,0,0,0,5.13,0A1.86,1.86,0,0,0,481.39,286.36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.73,283.44c.16.37-.15.87-.7,1.11s-1.12.13-1.28-.24.15-.86.69-1.1S477.57,283.07,477.73,283.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.63,285a.43.43,0,0,1-.28.53.42.42,0,0,1-.58-.16.48.48,0,0,1,.86-.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363,279.3a6,6,0,0,1,12,0v.34a3.1,3.1,0,0,1-1.76,2.28,9.36,9.36,0,0,1-8.5,0,3.11,3.11,0,0,1-1.75-2.28v-.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,274.06h0A6,6,0,0,1,375,279.3v.34a3.1,3.1,0,0,1-1.76,2.28,7.88,7.88,0,0,1-3,.94,3,3,0,0,0,2.08-3.93C371.78,276.71,369.53,273.49,366.41,274.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,279.64v-.34a6,6,0,0,1,2-4.34c-.65.67-2.1,3.2-.53,5.13,1,1.27,6,3.07,10,.75a4.08,4.08,0,0,1-1.27,1.08,9.36,9.36,0,0,1-8.5,0A3.11,3.11,0,0,1,363,279.64Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.07,274.82c-.26.61.25,1.43,1.16,1.82s1.86.23,2.12-.38-.24-1.43-1.15-1.83S369.34,274.2,369.07,274.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.55,277.31a.72.72,0,0,0,.46.89.64.64,0,1,0-.46-.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,280.84a8.71,8.71,0,0,1,17.41,0,2.89,2.89,0,0,1,0,.48,4.49,4.49,0,0,1-2.55,3.32,13.64,13.64,0,0,1-12.32,0,4.5,4.5,0,0,1-2.54-3.32,2.89,2.89,0,0,1,0-.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,273.24h0a8.7,8.7,0,0,1,12.49,7.6,2.89,2.89,0,0,1,0,.48,4.49,4.49,0,0,1-2.55,3.32,11.49,11.49,0,0,1-4.37,1.36c2.26-.39,3.72-2.91,3-5.7C387.93,277.07,384.67,272.4,380.14,273.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.22,281.32a2.89,2.89,0,0,1,0-.48,8.65,8.65,0,0,1,2.95-6.29c-.94,1-3.05,4.63-.76,7.43,1.5,1.84,8.64,4.46,14.52,1.09a6.12,6.12,0,0,1-1.85,1.57,13.64,13.64,0,0,1-12.32,0A4.5,4.5,0,0,1,375.22,281.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384,274.33c-.39.89.36,2.08,1.67,2.65s2.7.33,3.09-.56-.36-2.07-1.67-2.65S384.4,273.44,384,274.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.06,277.94a1.15,1.15,0,1,0,1.39-.38A1,1,0,0,0,389.06,277.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.09,286.16a8.26,8.26,0,0,1,16.52,0,2.65,2.65,0,0,1,0,.46,4.24,4.24,0,0,1-2.42,3.15,12.94,12.94,0,0,1-11.69,0,4.25,4.25,0,0,1-2.41-3.15,2.65,2.65,0,0,1,0-.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,279h0a8.16,8.16,0,0,1,3.59-.83,8.26,8.26,0,0,1,8.26,8,2.65,2.65,0,0,1,0,.46,4.24,4.24,0,0,1-2.42,3.15,10.88,10.88,0,0,1-4.14,1.29c2.14-.37,3.53-2.76,2.87-5.41C382.16,282.59,379.05,278.15,374.76,279Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.09,286.62a2.65,2.65,0,0,1,0-.46,8.2,8.2,0,0,1,2.8-6c-.9.92-2.89,4.4-.72,7.06,1.42,1.74,8.2,4.23,13.78,1a5.65,5.65,0,0,1-1.76,1.49,12.94,12.94,0,0,1-11.69,0A4.25,4.25,0,0,1,370.09,286.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.43,280c-.37.84.34,2,1.59,2.51s2.56.31,2.93-.53-.34-2-1.59-2.52S378.8,279.14,378.43,280Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.22,283.42a1.08,1.08,0,1,0,1.33-.37A1,1,0,0,0,383.22,283.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,293.88a10.26,10.26,0,0,1,20.52,0,4.21,4.21,0,0,1,0,.58c-.12,1.42-1.12,2.81-3,3.9a16.06,16.06,0,0,1-14.51,0c-1.88-1.09-2.88-2.48-3-3.9a4.21,4.21,0,0,1,0-.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.09,284.93h0a10.24,10.24,0,0,1,14.71,8.95,4.21,4.21,0,0,1,0,.58c-.12,1.42-1.12,2.81-3,3.9a13.61,13.61,0,0,1-5.14,1.61c2.66-.46,4.38-3.43,3.56-6.72C397.26,289.45,393.41,284,388.09,284.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,294.46a4.21,4.21,0,0,1,0-.58,10.23,10.23,0,0,1,3.49-7.41c-1.12,1.15-3.6,5.47-.9,8.76,1.77,2.16,10.18,5.25,17.1,1.28a7,7,0,0,1-2.18,1.85,16.06,16.06,0,0,1-14.51,0C383.4,297.27,382.4,295.88,382.28,294.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.64,286.22c-.45,1,.43,2.44,2,3.12s3.17.39,3.63-.66-.42-2.45-2-3.12S393.1,285.17,392.64,286.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.59,290.48a1.35,1.35,0,0,0,2.42,1.06,1.35,1.35,0,0,0-2.42-1.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.76,295.73a9.37,9.37,0,0,0-18.73,0,3.39,3.39,0,0,0,0,.52c.1,1.3,1,2.57,2.74,3.56a14.6,14.6,0,0,0,13.25,0,4.81,4.81,0,0,0,2.74-3.56v-.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,287.55h0A9.36,9.36,0,0,0,421,295.73a3.39,3.39,0,0,0,0,.52c.1,1.3,1,2.57,2.74,3.56a12.53,12.53,0,0,0,4.7,1.47c-2.43-.42-4-3.13-3.26-6.13C426.08,291.68,429.59,286.65,434.46,287.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.76,296.25v-.52a9.31,9.31,0,0,0-3.18-6.77c1,1,3.28,5,.82,8-1.62,2-9.3,4.8-15.62,1.18a6.52,6.52,0,0,0,2,1.68,14.6,14.6,0,0,0,13.25,0A4.81,4.81,0,0,0,439.76,296.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.74,
    cy: 289.85,
    rx: 2.79,
    ry: 1.89,
    transform: "translate(-80.45 196.46) rotate(-23.71)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.87,292.61a1.23,1.23,0,1,1-1.5-.41A1.12,1.12,0,0,1,424.87,292.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,296.74a8.91,8.91,0,0,1,17.82,0v.5a4.61,4.61,0,0,1-2.61,3.39,13.94,13.94,0,0,1-12.61,0,4.62,4.62,0,0,1-2.6-3.39v-.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.68,289h0a8.8,8.8,0,0,1,3.87-.89,8.92,8.92,0,0,1,8.91,8.66v.5a4.61,4.61,0,0,1-2.61,3.39,11.79,11.79,0,0,1-4.47,1.4c2.31-.4,3.81-3,3.1-5.83C413.65,292.89,410.31,288.12,405.68,289Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,297.24v-.5a8.86,8.86,0,0,1,3-6.43c-1,1-3.12,4.74-.78,7.6,1.54,1.88,8.84,4.57,14.85,1.12a6.38,6.38,0,0,1-1.89,1.6,13.94,13.94,0,0,1-12.61,0A4.62,4.62,0,0,1,400.64,297.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.64,290.09c-.4.91.37,2.12,1.71,2.71s2.76.33,3.16-.57-.37-2.13-1.71-2.72S410,289.18,409.64,290.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.8,293.78a1.17,1.17,0,1,0,1.43-.39A1.05,1.05,0,0,0,414.8,293.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,299.86a3.63,3.63,0,0,0-7.25,0v.2a1.87,1.87,0,0,0,1.06,1.38,5.66,5.66,0,0,0,5.13,0,1.85,1.85,0,0,0,1.06-1.38.34.34,0,0,0,0-.1A.31.31,0,0,0,423.75,299.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,296.69h0a3.63,3.63,0,0,0-5.2,3.17v.2a1.87,1.87,0,0,0,1.06,1.38,4.8,4.8,0,0,0,1.82.57,1.83,1.83,0,0,1-1.26-2.37C418.46,298.29,419.82,296.34,421.7,296.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,300.06a.34.34,0,0,0,0-.1.31.31,0,0,0,0-.1,3.57,3.57,0,0,0-1.23-2.62c.4.4,1.27,1.93.32,3.09-.63.77-3.6,1.86-6,.46a2.67,2.67,0,0,0,.77.65,5.66,5.66,0,0,0,5.13,0A1.85,1.85,0,0,0,423.75,300.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.09,297.15c.16.37-.15.86-.7,1.1s-1.12.14-1.28-.23.15-.87.69-1.11S419.93,296.78,420.09,297.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418,298.65a.43.43,0,0,1-.28.54.39.39,0,1,1,.28-.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,281.3a3.63,3.63,0,0,1,7.25,0v.2a1.89,1.89,0,0,1-1.06,1.38,5.68,5.68,0,0,1-5.14,0,1.87,1.87,0,0,1-1.05-1.38.38.38,0,0,1,0-.1A.31.31,0,0,1,357.28,281.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,281.3a3.63,3.63,0,0,1,7.25,0v.2a1.89,1.89,0,0,1-1.06,1.38,5.68,5.68,0,0,1-5.14,0,1.87,1.87,0,0,1-1.05-1.38.38.38,0,0,1,0-.1A.31.31,0,0,1,357.28,281.3Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,278.13h0a3.58,3.58,0,0,1,1.57-.36,3.63,3.63,0,0,1,3.63,3.53v.2a1.89,1.89,0,0,1-1.06,1.38,4.86,4.86,0,0,1-1.82.57,1.84,1.84,0,0,0,1.26-2.38C362.57,279.73,361.21,277.78,359.33,278.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.28,281.5a.38.38,0,0,1,0-.1.31.31,0,0,1,0-.1,3.57,3.57,0,0,1,1.23-2.63c-.4.41-1.27,1.94-.32,3.1.63.77,3.6,1.86,6.05.46a2.84,2.84,0,0,1-.77.65,5.68,5.68,0,0,1-5.14,0A1.87,1.87,0,0,1,357.28,281.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.94,278.59c-.16.37.15.86.7,1.1s1.12.14,1.28-.23-.15-.87-.7-1.11S361.1,278.22,360.94,278.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363,280.09a.48.48,0,0,0,.86.38.48.48,0,0,0-.86-.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flame--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.66,208.41l-6.91-1.79-6.9,1.79a27.79,27.79,0,0,0,.08,9.49c.9,5.8,4.94,11.59,6.82,11.59s5.93-5.79,6.83-11.59A27.79,27.79,0,0,0,425.66,208.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.27,209.24h-9.45c-1.35,8.17,3,14.43,4.73,14.43S424.62,217.41,423.27,209.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.55,209.24h1.62a7.21,7.21,0,0,1,.87,4.36c-.19,2.21-1.52,5.07-2.49,5.07s-2.3-2.86-2.5-5.07a7.16,7.16,0,0,1,.88-4.36h1.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.69,201.64h0l-1.36-14.45H404.18l-1.36,14.45h0c-.28,2.55,1.26,5.16,4.64,7.11,6.24,3.6,16.36,3.6,22.6,0C433.45,206.8,435,204.19,434.69,201.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.43,193.72c-5.72-3.29-5.72-8.64,0-11.93s15-3.3,20.68,0,5.71,8.64,0,11.93S414.14,197,408.43,193.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.38,198.1l-.46-4.84c-.42,1.86-1.86,3.67-4.34,5.1-6,3.44-15.65,3.44-21.62,0-2.49-1.43-3.93-3.24-4.35-5.1l-.46,4.84c.37,2,1.87,3.92,4.51,5.45,6.14,3.54,16.08,3.54,22.21,0C432.51,202,434,200.09,434.38,198.1Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.24,208.65l.44-.27h0a26.7,26.7,0,0,1-12,2.05c-7.26-.31-11.71-3.09-11.84-5.12a26.88,26.88,0,0,1,.31-5A26.52,26.52,0,0,0,419,202.67c8.13,0,13.07-2.81,15.3-5.39l-.23-2.41-.72-7.68H404.18l-1.36,14.45h0a5.35,5.35,0,0,0,0,1.44c0,.2.08.41.13.61s.17.54.28.81a9.6,9.6,0,0,0,4.19,4.25,23.11,23.11,0,0,0,11.3,2.7,25.74,25.74,0,0,0,3.05-.17q.76-.08,1.5-.21a20.35,20.35,0,0,0,6.75-2.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18,197.19h-.42c-6,.06-11.29-1.49-15-4.39a3.25,3.25,0,1,1,4-5.1c2.53,2,6.4,3.06,10.91,3h.09c4.51.05,8.38-1,10.91-3a3.25,3.25,0,1,1,4,5.1C430.14,195.64,425,197.19,419.18,197.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.48,179.32l2.46-29.76,9.89,5.71c4.74,2.74,6.87,9.76,6.09,20.13l-1.25,16.67L448,182.84c-1.45-5-5.15-6.77-10.49-4.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,179.32l-2.46-29.76-9.89,5.71c-4.75,2.74-6.87,9.76-6.09,20.13l1.25,16.67,2.67-9.23c1.45-5,5.15-6.77,10.49-4.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.43,126.11c0-31.79-13.43-59.27-23.42-65.63l-.26-.17-.05,0h0a3.79,3.79,0,0,0-1.93-.52,3.84,3.84,0,0,0-1.93.52h0l-.05,0-.27.17c-10,6.36-23.42,33.84-23.42,65.63,0,30.59,8.58,57.7,9.4,60.22l.06.19h0a9.53,9.53,0,0,0,4.51,4.85c6.47,3.73,16.94,3.73,23.4,0a9.34,9.34,0,0,0,4.58-5C435.86,183.81,444.43,156.7,444.43,126.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.32,68.12A28.22,28.22,0,0,0,421,60.48l-.26-.18a.05.05,0,0,1-.05,0h0a3.88,3.88,0,0,0-1.92-.52,4,4,0,0,0-1.94.52h0s0,0-.05,0l-.27.18a28.28,28.28,0,0,0-7.31,7.65,63.93,63.93,0,0,0-4.28,7.13,7.79,7.79,0,0,0,3.94,4.48c5.47,3.16,14.34,3.16,19.8,0a7.75,7.75,0,0,0,3.94-4.48A65.05,65.05,0,0,0,428.32,68.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.09,61.3l-1.33-13-1.32,13h0a.66.66,0,0,0,.38.54,2.08,2.08,0,0,0,1.88,0,.65.65,0,0,0,.39-.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09,126.11c0,30.59,8.58,57.7,9.4,60.22l.06.19h0a9.53,9.53,0,0,0,4.51,4.85,18.84,18.84,0,0,0,3.6,1.57,264.23,264.23,0,0,1-9.09-66.06c0-35.22,8.67-60.18,14.94-66.4C406.53,66.84,393.09,94.32,393.09,126.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.43,126.11c0,30.59-8.57,57.7-9.39,60.22l-.06.19h0a9.55,9.55,0,0,1-4.52,4.85c4.85-17.72,10.39-39,10.39-64.49,0-35.22-13.57-60.18-19.84-66.4C431,66.84,444.43,94.32,444.43,126.11Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.68,170.94l-9.29-17.13-2.45,1.42-4.27,26.92,4,3.26a30.14,30.14,0,0,1,10.49,17l2.66,12.31s1.17-7.83,2.46-17.3C452.46,189,452.43,179.16,447.68,170.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.67,182.15l4.27-26.92,9.28,17.12c4.75,8.23,5.67,17.71,4.89,27.18l-1.26,15.22-2.66-12.31a30.14,30.14,0,0,0-10.49-17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.83,170.94l9.29-17.13,2.45,1.42,4.27,26.92-4,3.26a30.09,30.09,0,0,0-10.49,17l-2.66,12.31s-1.17-7.83-2.46-17.3C385.05,189,385.08,179.16,389.83,170.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,182.15l-4.27-26.92-9.28,17.12c-4.75,8.23-5.67,17.71-4.89,27.18l1.26,15.22,2.66-12.31a30.09,30.09,0,0,1,10.49-17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 108.66,
    r: 10.52,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 108.66,
    r: 10.52,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 109.88,
    r: 10.52,
    transform: "translate(-10.17 168.62) rotate(-22.5)",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.55,119.69l-3.4-9.35,8.62,5L428,115l-8.62-5,9.8-1.72c0-.14-.05-.28-.07-.41l-9.8,1.73,6.39-7.62-.31-.27-6.4,7.62v-10h-.41v10l-6.4-7.62-.31.27,6.39,7.62-9.8-1.73c0,.13-.05.27-.07.41l9.8,1.72-8.62,5,.21.36,8.62-5L415,119.69l.39.14,3.4-9.35,3.41,9.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 109.88,
    r: 7.6,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.76,102.28a7.6,7.6,0,0,0-7.56,6.88,7.6,7.6,0,0,0,15.13,0A7.6,7.6,0,0,0,418.76,102.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.57,
    cy: 107.95,
    r: 2.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,112.44a1.31,1.31,0,1,1-1.3-1.31A1.31,1.31,0,0,1,423.41,112.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 135.2,
    r: 8.02,
    transform: "translate(-19.86 170.55) rotate(-22.5)",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 135.2,
    r: 8.02,
    transform: "translate(-19.86 170.55) rotate(-22.5)",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.76,
    cy: 136.13,
    r: 8.02,
    transform: "translate(-20.22 170.62) rotate(-22.5)",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.65,143.61l-2.59-7.13,6.57,3.8.15-.28-6.56-3.79,7.47-1.31-.06-.31-7.47,1.31,4.87-5.8-.24-.21-4.87,5.81v-7.58h-.31v7.58l-4.88-5.81-.24.21,4.88,5.8-7.47-1.31-.06.31,7.47,1.31L411.74,140c.05.1.11.19.16.28l6.57-3.8-2.59,7.13.29.11,2.59-7.13,2.6,7.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.55,136.13a5.79,5.79,0,1,1-5.79-5.79A5.79,5.79,0,0,1,424.55,136.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.76,130.34a5.28,5.28,0,1,0,5.77,5.28A5.79,5.79,0,0,0,418.76,130.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.39,134.66a1.73,1.73,0,1,1-1.73-1.73A1.74,1.74,0,0,1,423.39,134.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31,138.08a1,1,0,1,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bars--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.66,369.92a.59.59,0,0,1-.29-.07l-36.71-21.2a.57.57,0,0,1,0-1l45.89-26.49a.53.53,0,0,1,.57,0l36.71,21.19a.57.57,0,0,1,0,1l-45.89,26.5A.58.58,0,0,1,258.66,369.92Zm-35.59-21.76,35.59,20.54,44.76-25.84-35.58-20.54Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "258.66 364.06 258.65 221.16 231.12 205.26 231.12 348.16 258.66 364.06",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.66 364.06 258.65 221.16 231.12 205.26 231.12 348.16 258.66 364.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.66 364.06 295.37 342.86 295.38 199.96 258.65 221.16 258.66 364.06",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.38 199.96 267.84 184.06 231.12 205.26 258.65 221.16 295.38 199.96",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.38 199.96 267.84 184.06 231.12 205.26 258.65 221.16 295.38 199.96",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.38,200l-37.09,20.45-12-6.73-15.13-8.42L246,214.15l12.18,7.27c-.29,4.13-.37,125.84-.31,130a109.82,109.82,0,0,0,.81,12.67,109.81,109.81,0,0,0,.8-12.67c.06-4,0-125.57-.29-129.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.82,409.66a.55.55,0,0,1-.28-.07l-36.72-21.2a.56.56,0,0,1-.28-.49.58.58,0,0,1,.28-.49l45.9-26.49a.56.56,0,0,1,.56,0L236,382.12a.55.55,0,0,1,0,1l-45.89,26.5A.53.53,0,0,1,189.82,409.66ZM154.24,387.9l35.58,20.55,44.76-25.84L199,362.06Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 403.8 189.82 317.36 162.28 301.46 162.29 387.9 189.82 403.8",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 403.8 189.82 317.36 162.28 301.46 162.29 387.9 189.82 403.8",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 403.8 226.53 382.61 226.54 296.16 189.82 317.36 189.82 403.8",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 403.8 226.53 382.61 226.54 296.16 189.82 317.36 189.82 403.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.54 296.16 199 280.26 162.28 301.46 189.82 317.36 226.54 296.16",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.54 296.16 199 280.26 162.28 301.46 189.82 317.36 226.54 296.16",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.3,318l36.24-21.87-37.09,20.45c-4-2.27-8-4.49-12-6.73l-15.13-8.42,14.86,8.89c4.06,2.43,8.12,4.87,12.2,7.27-.13,4.28-.26,25-.3,29.25s-.07,26.31,0,30.69.1,8.75.24,13.12.29,8.75.57,13.12c.28-4.37.46-8.75.57-13.12s.21-8.75.24-13.12,0-26.32,0-30.69C190.56,342.72,190.43,322.18,190.3,318Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121,449.41a.6.6,0,0,1-.28-.08L84,428.14a.57.57,0,0,1,0-1l45.89-26.5a.58.58,0,0,1,.57,0l36.71,21.2a.57.57,0,0,1,0,1l-45.89,26.49A.6.6,0,0,1,121,449.41ZM85.4,427.65,121,448.19l44.76-25.84L130.16,401.8Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "120.98 443.54 120.98 403.48 93.44 387.58 93.45 427.65 120.98 443.54",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.98 443.54 120.98 403.48 93.44 387.58 93.45 427.65 120.98 443.54",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.98 443.54 157.7 422.35 157.7 382.28 120.98 403.48 120.98 443.54",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.98 443.54 157.7 422.35 157.7 382.28 120.98 403.48 120.98 443.54",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.7 382.28 130.17 366.39 93.44 387.58 120.98 403.48 157.7 382.28",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.7 382.28 130.17 366.39 93.44 387.58 120.98 403.48 157.7 382.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,382.28l-37.08,20.45L108.57,396l-15.13-8.42,14.86,8.89,12.17,7.27c-.28,2.51-.35,29.48-.3,32a43,43,0,0,0,.81,7.8,42.15,42.15,0,0,0,.81-7.8c0-2.39,0-29.23-.27-31.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.49,330.18a.6.6,0,0,1-.28-.08L290.5,308.91a.57.57,0,0,1,0-1l45.89-26.5a.58.58,0,0,1,.57,0l36.71,21.2a.57.57,0,0,1,0,1L327.78,330.1A.6.6,0,0,1,327.49,330.18Zm-35.58-21.76L327.49,329l44.77-25.84-35.59-20.54Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "327.49 324.31 327.49 117.34 299.95 101.44 299.96 308.42 327.49 324.31",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.49 324.31 327.49 117.34 299.95 101.44 299.96 308.42 327.49 324.31",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.49 324.31 364.21 303.12 364.21 96.15 327.49 117.34 327.49 324.31",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.49 324.31 364.21 303.12 364.21 96.15 327.49 117.34 327.49 324.31",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.21 96.15 336.68 80.25 299.95 101.44 327.49 117.34 364.21 96.15",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.21 96.15 336.68 80.25 299.95 101.44 327.49 117.34 364.21 96.15",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,118l36.23-21.87L327.12,116.6c-4-2.27-8-4.5-12-6.73L300,101.44l14.86,8.89c4.06,2.44,8.12,4.88,12.2,7.27-.13,4.86-.26,9.72-.3,14.58s-.06,157.52,0,162.46.1,9.89.24,14.84.29,9.89.57,14.84c.28-4.95.46-9.9.57-14.84s.22-9.89.24-14.84,0-157.52,0-162.46C328.23,127.46,328.1,122.74,328,118Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.33,344.21a6.23,6.23,0,0,1,2.26-6.27c2.5-2.08,5.88-2.94,6.21-2.73s0,3.65-2.6,6.43A7.33,7.33,0,0,1,436.33,344.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,352.15a6.24,6.24,0,0,1,4.88-4.55c3.18-.72,6.59.06,6.79.39s-1.68,3.25-5.27,4.54A7.35,7.35,0,0,1,434.85,352.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75,353.35a6.26,6.26,0,0,1-3.65-5.58c-.16-3.25.9-6.25,1.27-6.39s3.24,2.42,4.06,5.74C431.33,350.73,429.27,352.56,428.75,353.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.23,380.77A25.5,25.5,0,0,1,425,372a48.79,48.79,0,0,1,1.53-8,63.38,63.38,0,0,1,6.65-15.6,34.26,34.26,0,0,1,6.69-8.67c.06-.05.21.07.16.13a50.89,50.89,0,0,0-5.48,8.27,59.62,59.62,0,0,0-3.95,8,61.32,61.32,0,0,0-3.83,14.58,85.11,85.11,0,0,0-.47,10A.55.55,0,0,1,425.23,380.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.39,355.91a19.82,19.82,0,0,1-1.56-4.13,11,11,0,0,1-.43-4.19c0-.2.18.06.2.18a33.2,33.2,0,0,0,.88,3.67,14.6,14.6,0,0,0,1.72,3.61.9.9,0,0,1-.05,1A.48.48,0,0,1,429.39,355.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.72,355.46a16.08,16.08,0,0,1,4.88-3.75,18,18,0,0,1,2.55-1.21,11.42,11.42,0,0,1,3.25-.76c.05,0,.31.1.23.12-.87.26-2.16.76-3.07,1.15a17.78,17.78,0,0,0-2.63,1.4,26.91,26.91,0,0,0-4.67,3.67C430,356.37,429.49,355.74,429.72,355.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.36,363.33a6.26,6.26,0,0,1,3.82-5.47c3-1.36,6.46-1.31,6.72-1s-1,3.52-4.2,5.54A7.4,7.4,0,0,1,430.36,363.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,367.64a16.27,16.27,0,0,1,4-4.69,18.66,18.66,0,0,1,2.24-1.71,11,11,0,0,1,3-1.42s.32,0,.24.07a28.28,28.28,0,0,0-2.75,1.77,17.79,17.79,0,0,0-2.29,1.91,26.71,26.71,0,0,0-3.8,4.56C426.46,368.47,425.87,368,426,367.64Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.45,329.22a6.77,6.77,0,0,0-1.2-7.14c-2.27-2.71-5.72-4.28-6.11-4.12s-.71,3.9,1.54,7.38A8,8,0,0,0,415.45,329.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,338a6.78,6.78,0,0,0-4.34-5.8c-3.26-1.38-7-1.21-7.32-.89s1.16,3.8,4.75,5.87A8,8,0,0,0,415.49,338Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.78,340.44a6.79,6.79,0,0,0,5-5.26c.8-3.44.25-6.85-.11-7.07s-3.94,2-5.47,5.35C419.52,337.15,421.37,339.5,421.78,340.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.76,381.23c1.32-2.89,2.48-8.91,3.38-20.12a52.43,52.43,0,0,0-.08-8.86,68.85,68.85,0,0,0-4.08-18c-1.37-3.66-3-7.5-5.47-10.55-.05-.06-.24,0-.2.11a54.36,54.36,0,0,1,4.26,9.9,64.29,64.29,0,0,1,2.67,9.27,60.55,60.55,0,0,1,1.27,16.32,133.13,133.13,0,0,1-2.89,21.54A.6.6,0,0,0,418.76,381.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,343.05a21.45,21.45,0,0,0,2.47-4.11,11.93,11.93,0,0,0,1.27-4.39c0-.22-.2,0-.24.15a37,37,0,0,1-1.66,3.76,16,16,0,0,1-2.54,3.53,1,1,0,0,0-.13,1.09A.51.51,0,0,0,420.59,343.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,342.51a17.6,17.6,0,0,0-4.48-4.94,20,20,0,0,0-2.5-1.79,12.12,12.12,0,0,0-3.33-1.44s-.34,0-.26.09a31.8,31.8,0,0,1,3.05,1.82,18.59,18.59,0,0,1,2.54,2,28.4,28.4,0,0,1,4.28,4.82C419.89,343.44,420.52,342.85,420.33,342.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.12,350.8a6.78,6.78,0,0,0-3-6.58c-2.9-2-6.64-2.64-7-2.39s.34,3.95,3.42,6.73A8,8,0,0,0,418.12,350.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.91,356.24a17.7,17.7,0,0,0-3.36-5.78,20,20,0,0,0-2.06-2.26,12.29,12.29,0,0,0-3-2.1s-.34,0-.27,0a32,32,0,0,1,2.6,2.41,19,19,0,0,1,2.07,2.49,29.53,29.53,0,0,1,3.18,5.61C421.28,357.05,422,356.61,421.91,356.24Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.88,370.83a20.4,20.4,0,0,1,7.59-7c12.41-7.14,32.54-7.14,44.95,0a20.44,20.44,0,0,1,7.6,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.14-32.54,7.14-44.95,0-6-3.44-9.08-7.9-9.31-12.4h0v-6.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,370.83a20.4,20.4,0,0,1,7.59-7c12.41-7.14,32.54-7.14,44.95,0a20.44,20.44,0,0,1,7.6,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.14-32.54,7.14-44.95,0-6-3.44-9.08-7.9-9.31-12.4h0v-6.48Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,358.47c8.14,0,16.28,1.79,22.48,5.36a20.44,20.44,0,0,1,7.6,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-6.2,3.57-14.34,5.36-22.48,5.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,361.44a34.74,34.74,0,0,1,5.11,2.39,20.44,20.44,0,0,1,7.6,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4a34.74,34.74,0,0,1-5.11,2.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,361.44a35.35,35.35,0,0,0-5.12,2.39,20.4,20.4,0,0,0-7.59,7h-1.72v6.48h0c.23,4.5,3.34,9,9.31,12.4a35.35,35.35,0,0,0,5.12,2.39Z",
    style: {
      fill: "#092166",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,357.9c12.41,7.14,12.41,18.73,0,25.87-10.87,6.26-27.63,7-40,2.35h0l-.5-.19a35.12,35.12,0,0,1-4.49-2.16c-10.35-5.95-12.07-15-5.16-22h0a23.83,23.83,0,0,1,5.15-3.88C367.88,350.75,388,350.75,400.43,357.9Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,357.9c12.41,7.14,12.41,18.73,0,25.87-10.87,6.26-27.63,7-40,2.35h0l-.5-.19a35.12,35.12,0,0,1-4.49-2.16c-10.35-5.95-12.07-15-5.16-22h0a23.83,23.83,0,0,1,5.15-3.88C367.88,350.75,388,350.75,400.43,357.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,361.78A13.86,13.86,0,0,0,347,373.07c1.1,6.29,9.93,11.59,13,12.86a35.12,35.12,0,0,1-4.49-2.16C345.12,377.82,343.4,368.77,350.31,361.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.58,379.89a13.81,13.81,0,0,0,3.33-11.29c-1.1-6.29-9.94-11.58-13-12.86a34.49,34.49,0,0,1,4.49,2.16C410.78,363.86,412.5,372.9,405.58,379.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.96,
    cy: 370.81,
    rx: 29.55,
    ry: 17.01,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.96,
    cy: 370.81,
    rx: 29.55,
    ry: 17.01,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,375.89c-2.37-4.38-1.6-9.2,2.32-13.29a20.08,20.08,0,0,1,2.5-2.19,23.15,23.15,0,0,1,2.4-1.57c.47-.28.95-.54,1.45-.79-1.23,2-.78,4.17,6.18,4.58,13.62.79-3.64,13.77-3.64,13.77S352.18,372.17,349.75,375.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.16,372.3c-2.05-.23-3.06-2.32-2.27-4.68s3.1-4.08,5.14-3.85,3.06,2.32,2.27,4.68S353.2,372.53,351.16,372.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,383.12c.67-5.05,22.78-19,22.78-19s4.9-2,3.27-5.37a24.74,24.74,0,0,1,2.37,1.52c.51.37,1,.74,1.43,1.13,6.59,5.69,6.59,13.15,0,18.84-.44.38-.92.76-1.43,1.13a23.58,23.58,0,0,1-2.19,1.42c-.75.44-1.54.85-2.35,1.23-.64.3-1.31.59-2,.85s-1.37.52-2.07.75a43.54,43.54,0,0,1-6.6,1.58c-.49.08-1,.15-1.48.21a50.72,50.72,0,0,1-14.67-.24S373.33,386.43,372.7,383.12Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,383.12c.67-5.05,22.78-19,22.78-19s4.9-2,3.27-5.37a24.74,24.74,0,0,1,2.37,1.52c.51.37,1,.74,1.43,1.13,6.59,5.69,6.59,13.15,0,18.84-.44.38-.92.76-1.43,1.13a23.58,23.58,0,0,1-2.19,1.42c-.75.44-1.54.85-2.35,1.23-.64.3-1.31.59-2,.85s-1.37.52-2.07.75a43.54,43.54,0,0,1-6.6,1.58c-.49.08-1,.15-1.48.21a50.72,50.72,0,0,1-14.67-.24S373.33,386.43,372.7,383.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,361.85c8.24,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.59,5-22.53,5-31.13,0s-8.6-13,0-17.92c.35-.2.71-.4,1.08-.58C372.13,356.91,385.29,357.1,393.54,361.85Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,361.85c8.24,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.59,5-22.53,5-31.13,0s-8.6-13,0-17.92c.35-.2.71-.4,1.08-.58C372.13,356.91,385.29,357.1,393.54,361.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.84,362.24c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.39,0-17.13S384.62,357.51,392.84,362.24Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.84,362.24c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.39,0-17.13S384.62,357.51,392.84,362.24Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.84,365.62c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.94-5.35,4.36-6,6.88.61,2.51,2.6,4.94,6,6.87,8.22,4.73,21.54,4.73,29.76,0,3.36-1.93,5.34-4.36,6-6.87C398.18,370,396.2,367.56,392.84,365.62Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.84,365.62c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.94-5.35,4.36-6,6.88.61,2.51,2.6,4.94,6,6.87,8.22,4.73,21.54,4.73,29.76,0,3.36-1.93,5.34-4.36,6-6.87C398.18,370,396.2,367.56,392.84,365.62Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.21,374.46V372c0-1-.71-2-2.24-2.91l-.06,0a10.84,10.84,0,0,0-8.34-.76h0c-1.1.28-2.15.64-3.11,1a30.91,30.91,0,0,1-3.34,1h0a5.65,5.65,0,0,1-1.59.15,3.35,3.35,0,0,1-1.31-.34l.1-.08.33-.2c.3-.17.59-.31.88-.44a6.14,6.14,0,0,1,4.68-.1l2.7-2.72V364a12.87,12.87,0,0,0-7.38-.26,15.47,15.47,0,0,0-2.34.81l-2.7-1.56-3.22,1.86v2.49l1.1.63a2.73,2.73,0,0,0-.47,1.45v2.49c0,1,.74,2,2.29,2.91a9.39,9.39,0,0,0,4.45,1.28h.89a17.6,17.6,0,0,0,4.78-1l.93-.32-2.72,2.71V380a13.27,13.27,0,0,0,10.41-.45l2.66,1.54,3.22-1.86v-2.49l-1.1-.63A2.93,2.93,0,0,0,391.21,374.46Zm-6.79-.22a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.26.07c2.52-.88,4.62-1.66,6.42-.71A4.1,4.1,0,0,1,384.42,374.24Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57,368.24h0c-1.1.28-2.15.64-3.11,1a30.91,30.91,0,0,1-3.34,1h0a5.65,5.65,0,0,1-1.59.15,3.39,3.39,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2c.3-.17.59-.31.88-.44a6.14,6.14,0,0,1,4.68-.1l2.7-2.72a12.87,12.87,0,0,0-7.38-.26,15.47,15.47,0,0,0-2.34.81l-2.7-1.56-3.22,1.86,2.67,1.53,0,0c-2.7,2.05-2.76,4.18.28,5.93a9.39,9.39,0,0,0,4.45,1.28h.89a17.6,17.6,0,0,0,4.78-1c3.09-1,5.59-2.25,7.67-1.05,1.4.8,1,1.81-.52,2.69a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.27,13.27,0,0,0,10.41-.45l2.66,1.54,3.22-1.86-2.66-1.53c2.68-2.07,3-4.32-.14-6.14l-.06,0A10.84,10.84,0,0,0,380.57,368.24Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.57,368.24h0c-1.1.28-2.15.64-3.11,1a30.91,30.91,0,0,1-3.34,1h0a5.65,5.65,0,0,1-1.59.15,3.39,3.39,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2c.3-.17.59-.31.88-.44a6.14,6.14,0,0,1,4.68-.1l2.7-2.72a12.87,12.87,0,0,0-7.38-.26,15.47,15.47,0,0,0-2.34.81l-2.7-1.56-3.22,1.86,2.67,1.53,0,0c-2.7,2.05-2.76,4.18.28,5.93a9.39,9.39,0,0,0,4.45,1.28h.89a17.6,17.6,0,0,0,4.78-1c3.09-1,5.59-2.25,7.67-1.05,1.4.8,1,1.81-.52,2.69a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.27,13.27,0,0,0,10.41-.45l2.66,1.54,3.22-1.86-2.66-1.53c2.68-2.07,3-4.32-.14-6.14l-.06,0A10.84,10.84,0,0,0,380.57,368.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.23 364.87 367.48 363.4 370.15 364.57 367.45 363.01 364.23 364.87",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.12,363.86a15.08,15.08,0,0,1,6.92.23l-1.87,2.65,2.7-2.71A12.8,12.8,0,0,0,372.12,363.86Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,369l.06,0c3.12,1.82,2.82,4.07.14,6.14,2.37-2.58,1.94-4.38-.64-5.86a12.17,12.17,0,0,0-7.9-1.08A10.84,10.84,0,0,1,388.91,369Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.11 375.18 391.15 376.75 388.55 378.57 391.77 376.71 389.11 375.18",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.67,374.62a7,7,0,0,1-5.13.44l-3.06,2.42,2.83-2.83A6.94,6.94,0,0,0,383.67,374.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.08,370.24a4.19,4.19,0,0,1-3.86-.36c-.93-.8-.33-1.65,1.06-2.4-1.51,1-1.36,1.86-.32,2.46a3.39,3.39,0,0,0,1.53.45A5.65,5.65,0,0,0,374.08,370.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.87,366.42c-.23.21-2.16,2-1.31,3.81s3.75,3.15,6,3.4h0a9.39,9.39,0,0,1-4.45-1.28C364.11,370.6,364.17,368.47,366.87,366.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.45,360.84a20.48,20.48,0,0,1,7.59-7c12.42-7.15,32.54-7.15,45,0a20.48,20.48,0,0,1,7.59,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.42,7.14-32.54,7.14-45,0-6-3.44-9.08-7.9-9.31-12.4h0v-6.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.45,360.84a20.48,20.48,0,0,1,7.59-7c12.42-7.15,32.54-7.15,45,0a20.48,20.48,0,0,1,7.59,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.42,7.14-32.54,7.14-45,0-6-3.44-9.08-7.9-9.31-12.4h0v-6.48Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,348.48c8.14,0,16.27,1.79,22.48,5.36a20.48,20.48,0,0,1,7.59,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4-6.21,3.57-14.34,5.36-22.48,5.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.88,351.45a35.35,35.35,0,0,1,5.12,2.39,20.48,20.48,0,0,1,7.59,7h1.72v6.48h0c-.23,4.5-3.32,9-9.29,12.4a35.35,35.35,0,0,1-5.12,2.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,351.45a35.35,35.35,0,0,0-5.12,2.39,20.48,20.48,0,0,0-7.59,7h-1.72v6.48h0c.23,4.5,3.34,9,9.31,12.4a35.35,35.35,0,0,0,5.12,2.39Z",
    style: {
      fill: "#092166",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,347.91c12.41,7.14,12.41,18.73,0,25.87-10.86,6.25-27.63,7-40,2.35h0l-.49-.19a35.26,35.26,0,0,1-4.5-2.16c-10.35-6-12.07-15-5.15-22h0a23.83,23.83,0,0,1,5.15-3.88C371.46,340.76,391.58,340.76,404,347.91Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,347.91c12.41,7.14,12.41,18.73,0,25.87-10.86,6.25-27.63,7-40,2.35h0l-.49-.19a35.26,35.26,0,0,1-4.5-2.16c-10.35-6-12.07-15-5.15-22h0a23.83,23.83,0,0,1,5.15-3.88C371.46,340.76,391.58,340.76,404,347.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,351.79a13.81,13.81,0,0,0-3.33,11.29c1.1,6.29,9.93,11.58,13,12.86a35.26,35.26,0,0,1-4.5-2.16C348.69,367.82,347,358.78,353.89,351.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.16,369.9a13.86,13.86,0,0,0,3.32-11.29c-1.1-6.29-9.93-11.59-13-12.86a35.26,35.26,0,0,1,4.5,2.16C414.35,353.87,416.07,362.91,409.16,369.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.64,372.85c-11.54-6.65-11.54-17.42,0-24.06s30.25-6.64,41.79,0,11.54,17.41,0,24.06S372.18,379.49,360.64,372.85Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.64,372.85c-11.54-6.65-11.54-17.42,0-24.06s30.25-6.64,41.79,0,11.54,17.41,0,24.06S372.18,379.49,360.64,372.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.33,365.9c-2.38-4.38-1.61-9.2,2.31-13.3a21,21,0,0,1,2.51-2.18,24.1,24.1,0,0,1,2.39-1.57c.47-.28,1-.54,1.46-.79-1.23,2-.78,4.17,6.18,4.58,13.62.79-3.64,13.77-3.64,13.77S355.76,362.18,353.33,365.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.73,362.31c-2-.23-3.06-2.32-2.26-4.68s3.09-4.08,5.14-3.86,3.05,2.33,2.26,4.69S356.77,362.54,354.73,362.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,373.12c.67-5,22.78-19,22.78-19s4.91-2,3.28-5.38a25.29,25.29,0,0,1,2.36,1.53c.51.37,1,.74,1.44,1.13,6.58,5.68,6.59,13.15,0,18.84-.45.38-.93.76-1.44,1.13a24.32,24.32,0,0,1-2.19,1.42q-1.12.66-2.34,1.23c-.65.3-1.32.59-2,.85s-1.37.52-2.08.75a43.7,43.7,0,0,1-6.59,1.58c-.49.08-1,.15-1.49.21a51.6,51.6,0,0,1-6.59.42,50.22,50.22,0,0,1-8.07-.67S376.91,376.44,376.27,373.12Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,373.12c.67-5,22.78-19,22.78-19s4.91-2,3.28-5.38a25.29,25.29,0,0,1,2.36,1.53c.51.37,1,.74,1.44,1.13,6.58,5.68,6.59,13.15,0,18.84-.45.38-.93.76-1.44,1.13a24.32,24.32,0,0,1-2.19,1.42q-1.12.66-2.34,1.23c-.65.3-1.32.59-2,.85s-1.37.52-2.08.75a43.7,43.7,0,0,1-6.59,1.58c-.49.08-1,.15-1.49.21a51.6,51.6,0,0,1-6.59.42,50.22,50.22,0,0,1-8.07-.67S376.91,376.44,376.27,373.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.11,351.86c8.25,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.6,5-22.54,5-31.13,0s-8.6-13,0-17.92c.35-.2.72-.4,1.08-.58C375.7,346.92,388.86,347.11,397.11,351.86Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.11,351.86c8.25,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.6,5-22.54,5-31.13,0s-8.6-13,0-17.92c.35-.2.72-.4,1.08-.58C375.7,346.92,388.86,347.11,397.11,351.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,352.25c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.4,0-17.13S388.19,347.52,396.41,352.25Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,352.25c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.4,0-17.13S388.19,347.52,396.41,352.25Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,355.63c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.94-5.34,4.36-6,6.88.62,2.51,2.6,4.94,6,6.87,8.22,4.73,21.54,4.73,29.76,0,3.36-1.93,5.35-4.36,6-6.87C401.76,360,399.77,357.57,396.41,355.63Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.41,355.63c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.94-5.34,4.36-6,6.88.62,2.51,2.6,4.94,6,6.87,8.22,4.73,21.54,4.73,29.76,0,3.36-1.93,5.35-4.36,6-6.87C401.76,360,399.77,357.57,396.41,355.63Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,364.47c0-.41,0-2.08,0-2.51,0-1-.72-2-2.25-2.91l-.05,0a10.87,10.87,0,0,0-8.35-.76h0c-1.11.28-2.16.64-3.12,1a30.24,30.24,0,0,1-3.34,1h0a5.68,5.68,0,0,1-1.59.15,3.35,3.35,0,0,1-1.32-.34l.11-.08.33-.2a6.57,6.57,0,0,1,.88-.44,6.09,6.09,0,0,1,4.68-.1l2.69-2.72V354a12.84,12.84,0,0,0-7.37-.26,14.22,14.22,0,0,0-2.35.81L371,353l-3.22,1.86v2.49l1.11.63a2.66,2.66,0,0,0-.48,1.45c0,.42,0,2.07,0,2.49,0,1,.74,2,2.29,2.91a9.32,9.32,0,0,0,4.44,1.28h0a8.84,8.84,0,0,0,.89,0,18,18,0,0,0,4.77-1l.93-.32-2.71,2.71V370a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86v-2.49l-1.11-.63A2.87,2.87,0,0,0,394.78,364.47Zm-6.79-.22a7.39,7.39,0,0,1-.74.38,7,7,0,0,1-5.27.07c2.52-.88,4.63-1.66,6.42-.71A3.21,3.21,0,0,1,388,364.25Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.14,358.25h0c-1.11.28-2.16.64-3.12,1a30.24,30.24,0,0,1-3.34,1h0a5.72,5.72,0,0,1-1.59.15,3.31,3.31,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2a6.57,6.57,0,0,1,.88-.44,6.09,6.09,0,0,1,4.68-.1l2.69-2.72a12.84,12.84,0,0,0-7.37-.26,14.22,14.22,0,0,0-2.35.81L371,353l-3.22,1.86,2.67,1.53,0,0c-2.71,2.05-2.77,4.18.28,5.93a9.32,9.32,0,0,0,4.44,1.28h0a8.84,8.84,0,0,0,.89,0,18,18,0,0,0,4.77-1c3.09-1,5.6-2.25,7.68-1.05,1.39.8,1,1.81-.53,2.69a7.39,7.39,0,0,1-.74.38,7,7,0,0,1-5.37,0l-2.82,2.83a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86-2.67-1.53c2.68-2.07,3-4.32-.14-6.14l-.05,0A10.87,10.87,0,0,0,384.14,358.25Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.14,358.25h0c-1.11.28-2.16.64-3.12,1a30.24,30.24,0,0,1-3.34,1h0a5.72,5.72,0,0,1-1.59.15,3.31,3.31,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2a6.57,6.57,0,0,1,.88-.44,6.09,6.09,0,0,1,4.68-.1l2.69-2.72a12.84,12.84,0,0,0-7.37-.26,14.22,14.22,0,0,0-2.35.81L371,353l-3.22,1.86,2.67,1.53,0,0c-2.71,2.05-2.77,4.18.28,5.93a9.32,9.32,0,0,0,4.44,1.28h0a8.84,8.84,0,0,0,.89,0,18,18,0,0,0,4.77-1c3.09-1,5.6-2.25,7.68-1.05,1.39.8,1,1.81-.53,2.69a7.39,7.39,0,0,1-.74.38,7,7,0,0,1-5.37,0l-2.82,2.83a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86-2.67-1.53c2.68-2.07,3-4.32-.14-6.14l-.05,0A10.87,10.87,0,0,0,384.14,358.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "367.81 354.88 371.06 353.41 373.72 354.58 371.02 353.02 367.81 354.88",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69,353.87a15.08,15.08,0,0,1,6.92.23l-1.86,2.65,2.69-2.72A12.87,12.87,0,0,0,375.69,353.87Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.49,359l.05,0c3.13,1.82,2.82,4.07.14,6.14,2.37-2.58,1.95-4.38-.63-5.86a12.2,12.2,0,0,0-7.91-1.08A10.87,10.87,0,0,1,392.49,359Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.68 365.19 394.72 366.75 392.13 368.57 395.35 366.72 392.68 365.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,364.63a7,7,0,0,1-5.13.44l-3.06,2.42,2.82-2.83A7,7,0,0,0,387.25,364.63Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.66,360.25a4.19,4.19,0,0,1-3.86-.36c-.93-.8-.33-1.66,1.06-2.4-1.51,1-1.36,1.86-.32,2.46a3.31,3.31,0,0,0,1.53.45A5.72,5.72,0,0,0,377.66,360.25Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,356.43c-.23.2-2.17,2-1.31,3.81s3.75,3.15,6,3.4h0a9.32,9.32,0,0,1-4.44-1.28C367.68,360.61,367.74,358.48,370.45,356.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.58,352.4a20.42,20.42,0,0,1,7.59-7c12.41-7.14,32.54-7.14,44.95,0a20.46,20.46,0,0,1,7.6,7h1.72v6.47h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.15-32.54,7.15-44.95,0-6-3.43-9.08-7.9-9.31-12.4h0V352.4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58,352.4a20.42,20.42,0,0,1,7.59-7c12.41-7.14,32.54-7.14,44.95,0a20.46,20.46,0,0,1,7.6,7h1.72v6.47h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.15-32.54,7.15-44.95,0-6-3.43-9.08-7.9-9.31-12.4h0V352.4Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65,340c8.13,0,16.27,1.79,22.47,5.36a20.46,20.46,0,0,1,7.6,7h1.72v6.47h0c-.23,4.5-3.32,9-9.29,12.4-6.2,3.57-14.34,5.36-22.47,5.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,343a34.71,34.71,0,0,1,5.11,2.38,20.46,20.46,0,0,1,7.6,7h1.72v6.47h0c-.23,4.5-3.32,9-9.29,12.4a33.75,33.75,0,0,1-5.11,2.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.29,343a35.32,35.32,0,0,0-5.12,2.38,20.42,20.42,0,0,0-7.59,7h-1.72v6.47h0c.23,4.5,3.34,9,9.31,12.4a34.32,34.32,0,0,0,5.12,2.39Z",
    style: {
      fill: "#092166",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,339.46c12.41,7.15,12.41,18.73,0,25.88-10.87,6.25-27.63,7-40,2.34h0l-.5-.19a35.08,35.08,0,0,1-4.49-2.15c-10.35-6-12.07-15-5.16-22h0a24.15,24.15,0,0,1,5.15-3.88C361.58,332.31,381.71,332.31,394.13,339.46Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,339.46c12.41,7.15,12.41,18.73,0,25.88-10.87,6.25-27.63,7-40,2.34h0l-.5-.19a35.08,35.08,0,0,1-4.49-2.15c-10.35-6-12.07-15-5.16-22h0a24.15,24.15,0,0,1,5.15-3.88C361.58,332.31,381.71,332.31,394.13,339.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,343.35a13.84,13.84,0,0,0-3.32,11.29c1.1,6.29,9.93,11.58,13,12.85a35.08,35.08,0,0,1-4.49-2.15C338.82,359.38,337.1,350.33,344,343.35Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.28,361.45a13.81,13.81,0,0,0,3.33-11.29c-1.1-6.29-9.94-11.58-13-12.85a33.2,33.2,0,0,1,4.49,2.15C404.48,345.42,406.2,354.47,399.28,361.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,364.4c-11.54-6.64-11.54-17.41,0-24s30.25-6.65,41.79,0,11.54,17.41,0,24S362.3,371,350.76,364.4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,364.4c-11.54-6.64-11.54-17.41,0-24s30.25-6.65,41.79,0,11.54,17.41,0,24S362.3,371,350.76,364.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.45,357.45c-2.37-4.37-1.6-9.2,2.32-13.29a20.08,20.08,0,0,1,2.5-2.19,24.9,24.9,0,0,1,2.4-1.57c.47-.27.95-.54,1.45-.79-1.23,2-.78,4.18,6.18,4.58,13.62.8-3.64,13.77-3.64,13.77S345.88,353.74,343.45,357.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,353.86c-2.05-.22-3.06-2.32-2.27-4.68s3.1-4.08,5.14-3.85,3.06,2.32,2.27,4.68S346.9,354.09,344.86,353.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4,364.68c.67-5,22.78-19,22.78-19s4.9-2,3.27-5.38a24.74,24.74,0,0,1,2.37,1.52c.51.37,1,.75,1.43,1.14,6.59,5.68,6.59,13.14,0,18.83-.44.39-.92.77-1.43,1.14-.68.49-1.41,1-2.19,1.42s-1.54.84-2.35,1.22c-.64.31-1.31.59-2,.86s-1.37.51-2.07.74a43.54,43.54,0,0,1-6.6,1.58l-1.48.22a51.18,51.18,0,0,1-14.66-.25S367,368,366.4,364.68Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4,364.68c.67-5,22.78-19,22.78-19s4.9-2,3.27-5.38a24.74,24.74,0,0,1,2.37,1.52c.51.37,1,.75,1.43,1.14,6.59,5.68,6.59,13.14,0,18.83-.44.39-.92.77-1.43,1.14-.68.49-1.41,1-2.19,1.42s-1.54.84-2.35,1.22c-.64.31-1.31.59-2,.86s-1.37.51-2.07.74a43.54,43.54,0,0,1-6.6,1.58l-1.48.22a51.18,51.18,0,0,1-14.66-.25S367,368,366.4,364.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.24,343.41c8.24,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.59,4.95-22.53,4.95-31.13,0s-8.6-13,0-17.92c.35-.2.71-.39,1.08-.58C365.83,338.47,379,338.67,387.24,343.41Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.24,343.41c8.24,4.75,8.58,12.32,1,17.3-.32.21-.66.42-1,.62-8.59,4.95-22.53,4.95-31.13,0s-8.6-13,0-17.92c.35-.2.71-.39,1.08-.58C365.83,338.47,379,338.67,387.24,343.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.54,343.81c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.4,0-17.13S378.32,339.08,386.54,343.81Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.54,343.81c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.76,0-8.22-12.4,0-17.13S378.32,339.08,386.54,343.81Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.54,347.19c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.93-5.35,4.36-6,6.87.61,2.52,2.6,4.94,6,6.88,8.22,4.73,21.54,4.73,29.76,0,3.36-1.94,5.34-4.36,5.95-6.88C391.88,351.55,389.9,349.12,386.54,347.19Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.54,347.19c-8.22-4.73-21.54-4.73-29.76,0-3.36,1.93-5.35,4.36-6,6.87.61,2.52,2.6,4.94,6,6.88,8.22,4.73,21.54,4.73,29.76,0,3.36-1.94,5.34-4.36,5.95-6.88C391.88,351.55,389.9,349.12,386.54,347.19Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.91,356v-2.5c0-1-.71-2-2.24-2.92l-.06,0a10.8,10.8,0,0,0-8.34-.77h0c-1.1.28-2.15.63-3.11,1a30.91,30.91,0,0,1-3.34,1h0a6,6,0,0,1-1.59.15,3.36,3.36,0,0,1-1.31-.35l.1-.07.33-.21a7.89,7.89,0,0,1,.88-.43,6.14,6.14,0,0,1,4.68-.11l2.7-2.71v-2.49a12.87,12.87,0,0,0-7.38-.27,15.47,15.47,0,0,0-2.34.81l-2.7-1.55-3.22,1.85v2.49l1.1.64a2.68,2.68,0,0,0-.47,1.45v2.48c0,1,.74,2,2.29,2.92a9.49,9.49,0,0,0,4.45,1.27h.89a17.6,17.6,0,0,0,4.78-1l.93-.32-2.72,2.72v2.49a13.31,13.31,0,0,0,10.41-.45l2.66,1.53,3.22-1.85v-2.49l-1.1-.64A2.9,2.9,0,0,0,384.91,356Zm-6.79-.21c-.25.14-.5.26-.75.37a6.94,6.94,0,0,1-5.26.08c2.52-.89,4.62-1.66,6.42-.71Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,349.8h0c-1.1.28-2.15.63-3.11,1a30.91,30.91,0,0,1-3.34,1h0a6,6,0,0,1-1.59.15,3.4,3.4,0,0,1-1.53-.46c-1-.59-1.19-1.47.32-2.45l.33-.21a7.89,7.89,0,0,1,.88-.43,6.14,6.14,0,0,1,4.68-.11l2.7-2.71a12.87,12.87,0,0,0-7.38-.27,15.47,15.47,0,0,0-2.34.81l-2.7-1.55-3.22,1.85L360.6,348l0,0c-2.7,2.05-2.76,4.17.28,5.93a9.49,9.49,0,0,0,4.45,1.27h.89a17.6,17.6,0,0,0,4.78-1c3.09-1,5.59-2.24,7.67-1.05,1.4.81,1,1.82-.52,2.7-.25.14-.5.26-.75.37a6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.31,13.31,0,0,0,10.41-.45l2.66,1.53,3.22-1.85-2.66-1.54c2.68-2.06,3-4.31-.14-6.14l-.06,0A10.8,10.8,0,0,0,374.27,349.8Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.27,349.8h0c-1.1.28-2.15.63-3.11,1a30.91,30.91,0,0,1-3.34,1h0a6,6,0,0,1-1.59.15,3.4,3.4,0,0,1-1.53-.46c-1-.59-1.19-1.47.32-2.45l.33-.21a7.89,7.89,0,0,1,.88-.43,6.14,6.14,0,0,1,4.68-.11l2.7-2.71a12.87,12.87,0,0,0-7.38-.27,15.47,15.47,0,0,0-2.34.81l-2.7-1.55-3.22,1.85L360.6,348l0,0c-2.7,2.05-2.76,4.17.28,5.93a9.49,9.49,0,0,0,4.45,1.27h.89a17.6,17.6,0,0,0,4.78-1c3.09-1,5.59-2.24,7.67-1.05,1.4.81,1,1.82-.52,2.7-.25.14-.5.26-.75.37a6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.31,13.31,0,0,0,10.41-.45l2.66,1.53,3.22-1.85-2.66-1.54c2.68-2.06,3-4.31-.14-6.14l-.06,0A10.8,10.8,0,0,0,374.27,349.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "357.93 346.43 361.18 344.96 363.85 346.13 361.15 344.58 357.93 346.43",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.82,345.42a15.1,15.1,0,0,1,6.92.24l-1.87,2.64,2.7-2.71A12.88,12.88,0,0,0,365.82,345.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.61,350.57l.06,0c3.12,1.83,2.82,4.08.14,6.14,2.37-2.58,1.94-4.37-.64-5.86a12.24,12.24,0,0,0-7.9-1.08A10.8,10.8,0,0,1,382.61,350.57Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.81 356.74 384.85 358.31 382.25 360.13 385.47 358.28 382.81 356.74",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,356.18a6.93,6.93,0,0,1-5.13.45l-3.06,2.42,2.83-2.83A6.94,6.94,0,0,0,377.37,356.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78,351.81a4.22,4.22,0,0,1-3.86-.37c-.93-.8-.33-1.65,1.06-2.39-1.51,1-1.36,1.86-.32,2.45a3.4,3.4,0,0,0,1.53.46A6,6,0,0,0,367.78,351.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.57,348c-.23.2-2.16,2-1.31,3.8s3.75,3.15,6,3.4h0a9.49,9.49,0,0,1-4.45-1.27C357.81,352.16,357.87,350,360.57,348Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.61,388.15a20.44,20.44,0,0,1,7.6-7c12.41-7.14,32.54-7.14,45,0a20.44,20.44,0,0,1,7.6,7h1.71v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.14-32.54,7.14-45,0-6-3.44-9.09-7.9-9.31-12.4h0v-6.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,388.15a20.44,20.44,0,0,1,7.6-7c12.41-7.14,32.54-7.14,45,0a20.44,20.44,0,0,1,7.6,7h1.71v6.48h0c-.23,4.5-3.32,9-9.29,12.4-12.41,7.14-32.54,7.14-45,0-6-3.44-9.09-7.9-9.31-12.4h0v-6.48Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.68,375.79c8.14,0,16.27,1.79,22.48,5.36a20.44,20.44,0,0,1,7.6,7h1.71v6.48h0c-.23,4.5-3.32,9-9.29,12.4-6.21,3.57-14.34,5.36-22.48,5.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.05,378.76a35.23,35.23,0,0,1,5.11,2.39,20.44,20.44,0,0,1,7.6,7h1.71v6.48h0c-.23,4.5-3.32,9-9.29,12.4a35.23,35.23,0,0,1-5.11,2.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.32,378.76a35.23,35.23,0,0,0-5.11,2.39,20.44,20.44,0,0,0-7.6,7H403.9v6.48h0c.22,4.5,3.34,9,9.31,12.4a35.23,35.23,0,0,0,5.11,2.39Z",
    style: {
      fill: "#092166",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,375.22c12.42,7.14,12.42,18.73,0,25.87-10.86,6.26-27.63,7-40,2.35h0l-.49-.19a34.49,34.49,0,0,1-4.49-2.16c-10.36-6-12.08-15-5.16-22h0a24.15,24.15,0,0,1,5.16-3.88C425.62,368.07,445.75,368.07,458.16,375.22Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16,375.22c12.42,7.14,12.42,18.73,0,25.87-10.86,6.26-27.63,7-40,2.35h0l-.49-.19a34.49,34.49,0,0,1-4.49-2.16c-10.36-6-12.08-15-5.16-22h0a24.15,24.15,0,0,1,5.16-3.88C425.62,368.07,445.75,368.07,458.16,375.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.05,379.1a13.85,13.85,0,0,0-3.33,11.29c1.1,6.29,9.94,11.59,13,12.86a34.49,34.49,0,0,1-4.49-2.16C402.85,395.13,401.13,386.09,408.05,379.1Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.32,397.21a13.86,13.86,0,0,0,3.32-11.29c-1.1-6.29-9.93-11.58-13-12.86a35.12,35.12,0,0,1,4.49,2.16C468.51,381.18,470.23,390.22,463.32,397.21Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,400.16c-11.54-6.64-11.54-17.41,0-24.06s30.25-6.64,41.79,0,11.54,17.42,0,24.06S426.34,406.8,414.8,400.16Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,400.16c-11.54-6.64-11.54-17.41,0-24.06s30.25-6.64,41.79,0,11.54,17.42,0,24.06S426.34,406.8,414.8,400.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.49,393.21c-2.38-4.38-1.6-9.2,2.32-13.29a19.39,19.39,0,0,1,2.5-2.19,24.1,24.1,0,0,1,2.39-1.57c.48-.28,1-.54,1.46-.79-1.23,2-.78,4.17,6.18,4.58,13.62.79-3.64,13.77-3.64,13.77S409.92,389.49,407.49,393.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.89,389.62c-2-.23-3.05-2.32-2.26-4.68s3.1-4.08,5.14-3.85,3.06,2.32,2.26,4.68S410.94,389.85,408.89,389.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.44,400.44c.67-5.05,22.78-19,22.78-19s4.9-2,3.27-5.38a25.29,25.29,0,0,1,2.36,1.53c.52.37,1,.74,1.44,1.13,6.58,5.69,6.59,13.15,0,18.84-.45.38-.93.76-1.44,1.13a21.19,21.19,0,0,1-2.19,1.42q-1.12.66-2.34,1.23c-.64.3-1.31.59-2,.85s-1.37.52-2.07.75a43.54,43.54,0,0,1-6.6,1.58c-.49.08-1,.15-1.48.21a50.72,50.72,0,0,1-14.67-.24S431.07,403.75,430.44,400.44Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.44,400.44c.67-5.05,22.78-19,22.78-19s4.9-2,3.27-5.38a25.29,25.29,0,0,1,2.36,1.53c.52.37,1,.74,1.44,1.13,6.58,5.69,6.59,13.15,0,18.84-.45.38-.93.76-1.44,1.13a21.19,21.19,0,0,1-2.19,1.42q-1.12.66-2.34,1.23c-.64.3-1.31.59-2,.85s-1.37.52-2.07.75a43.54,43.54,0,0,1-6.6,1.58c-.49.08-1,.15-1.48.21a50.72,50.72,0,0,1-14.67-.24S431.07,403.75,430.44,400.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,379.17c8.25,4.75,8.59,12.32,1,17.3-.32.21-.66.42-1,.62-8.6,5-22.53,5-31.13,0s-8.6-13,0-17.92c.35-.2.71-.4,1.08-.58C429.87,374.23,443,374.42,451.27,379.17Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,379.17c8.25,4.75,8.59,12.32,1,17.3-.32.21-.66.42-1,.62-8.6,5-22.53,5-31.13,0s-8.6-13,0-17.92c.35-.2.71-.4,1.08-.58C429.87,374.23,443,374.42,451.27,379.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,379.56c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.75,0-8.22-12.4,0-17.13S442.36,374.83,450.57,379.56Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,379.56c8.22,4.73,8.22,12.4,0,17.13s-21.54,4.73-29.75,0-8.22-12.4,0-17.13S442.36,374.83,450.57,379.56Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,382.94c-8.21-4.73-21.54-4.73-29.75,0-3.37,1.94-5.35,4.36-6,6.88.61,2.51,2.59,4.94,6,6.87,8.21,4.73,21.54,4.73,29.75,0,3.37-1.93,5.35-4.36,6-6.87C455.92,387.3,453.94,384.88,450.57,382.94Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,382.94c-8.21-4.73-21.54-4.73-29.75,0-3.37,1.94-5.35,4.36-6,6.88.61,2.51,2.59,4.94,6,6.87,8.21,4.73,21.54,4.73,29.75,0,3.37-1.93,5.35-4.36,6-6.87C455.92,387.3,453.94,384.88,450.57,382.94Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,391.78c0-.41,0-2.08,0-2.51,0-1-.71-2-2.25-2.91a.1.1,0,0,0-.05,0,10.87,10.87,0,0,0-8.35-.76h0c-1.1.28-2.15.64-3.11,1a30.32,30.32,0,0,1-3.35,1h0a5.65,5.65,0,0,1-1.59.15,3.35,3.35,0,0,1-1.32-.34l.11-.08.33-.2a9,9,0,0,1,.88-.44,6.14,6.14,0,0,1,4.68-.1l2.7-2.72v-2.49a12.87,12.87,0,0,0-7.38-.26,15.58,15.58,0,0,0-2.35.81l-2.69-1.56L422,382.19v2.49l1.1.63a2.57,2.57,0,0,0-.47,1.45v2.49c0,1,.74,2,2.29,2.91a9.33,9.33,0,0,0,4.45,1.28h0a8.77,8.77,0,0,0,.89,0,17.68,17.68,0,0,0,4.78-1l.92-.32-2.71,2.71v2.49a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86V394l-1.11-.63A2.94,2.94,0,0,0,449,391.78Zm-6.79-.22a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.26.07c2.52-.88,4.62-1.66,6.42-.71A4.1,4.1,0,0,1,442.16,391.56Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.3,385.56h0c-1.1.28-2.15.64-3.11,1a30.32,30.32,0,0,1-3.35,1h0a5.65,5.65,0,0,1-1.59.15,3.35,3.35,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2a9,9,0,0,1,.88-.44,6.09,6.09,0,0,1,4.68-.1l2.7-2.72a12.87,12.87,0,0,0-7.38-.26,15.58,15.58,0,0,0-2.35.81l-2.69-1.56L422,382.19l2.66,1.53,0,0c-2.71,2.05-2.76,4.18.28,5.93a9.33,9.33,0,0,0,4.45,1.28h0a8.77,8.77,0,0,0,.89,0,17.68,17.68,0,0,0,4.78-1c3.09-1,5.59-2.25,7.67-1.05,1.39.8,1,1.81-.52,2.69a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86-2.67-1.53c2.68-2.07,3-4.32-.14-6.14a.1.1,0,0,0-.05,0A10.87,10.87,0,0,0,438.3,385.56Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.3,385.56h0c-1.1.28-2.15.64-3.11,1a30.32,30.32,0,0,1-3.35,1h0a5.65,5.65,0,0,1-1.59.15,3.35,3.35,0,0,1-1.53-.45c-1-.6-1.19-1.47.32-2.46l.33-.2a9,9,0,0,1,.88-.44,6.09,6.09,0,0,1,4.68-.1l2.7-2.72a12.87,12.87,0,0,0-7.38-.26,15.58,15.58,0,0,0-2.35.81l-2.69-1.56L422,382.19l2.66,1.53,0,0c-2.71,2.05-2.76,4.18.28,5.93a9.33,9.33,0,0,0,4.45,1.28h0a8.77,8.77,0,0,0,.89,0,17.68,17.68,0,0,0,4.78-1c3.09-1,5.59-2.25,7.67-1.05,1.39.8,1,1.81-.52,2.69a6.61,6.61,0,0,1-.75.38,6.94,6.94,0,0,1-5.36,0l-2.83,2.83a13.24,13.24,0,0,0,10.4-.45l2.67,1.54,3.22-1.86-2.67-1.53c2.68-2.07,3-4.32-.14-6.14a.1.1,0,0,0-.05,0A10.87,10.87,0,0,0,438.3,385.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "421.97 382.19 425.22 380.72 427.88 381.89 425.19 380.33 421.97 382.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,381.18a15.08,15.08,0,0,1,6.92.23l-1.87,2.65,2.7-2.71A12.8,12.8,0,0,0,429.86,381.18Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.65,386.32a.1.1,0,0,1,.05,0c3.13,1.82,2.82,4.07.14,6.14,2.38-2.58,2-4.38-.63-5.86a12.2,12.2,0,0,0-7.91-1.08A10.87,10.87,0,0,1,446.65,386.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.84 392.5 448.89 394.06 446.29 395.89 449.51 394.03 446.84 392.5",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.41,391.94a7,7,0,0,1-5.13.44l-3.06,2.42,2.83-2.83A6.94,6.94,0,0,0,441.41,391.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.82,387.56a4.19,4.19,0,0,1-3.86-.36c-.93-.8-.33-1.65,1.06-2.4-1.51,1-1.36,1.86-.32,2.46a3.35,3.35,0,0,0,1.53.45A5.65,5.65,0,0,0,431.82,387.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.61,383.74c-.23.2-2.17,2-1.31,3.81s3.75,3.15,6,3.4h0a9.33,9.33,0,0,1-4.45-1.28C421.85,387.92,421.9,385.79,424.61,383.74Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--target--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--target--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.93,31.41c4.59-2.66,10.93-2.28,17.95,1.77,14,8.09,25.37,27.78,25.37,44,0,8.12-2.86,13.82-7.48,16.45-1.21.69-6.07,3.62-7.28,4.32-4.59,2.66-10.93,2.28-17.94-1.77-14-8.09-25.38-27.77-25.38-44,0-8.08,2.84-13.77,7.43-16.42",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25,77.14h0c0,8.12-2.86,13.82-7.48,16.45-1.21.69-6.07,3.62-7.28,4.32-4.59,2.66-10.93,2.28-17.94-1.76Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.55,59.75a47.11,47.11,0,0,1,3.7,17.39l-32.7,19h0a46.84,46.84,0,0,1-13.2-11.9Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.35,84.24c-7.3-9.36-12.18-21.46-12.18-32.06,0-8.08,2.84-13.77,7.43-16.42l7.33-4.35c4.59-2.66,10.93-2.28,17.95,1.77,9.18,5.3,17.21,15.57,21.67,26.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,37.53c14,8.1,25.38,27.78,25.38,44s-11.37,22.75-25.38,14.65-25.39-27.77-25.38-44S304.55,29.44,318.55,37.53Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,37.53c14,8.1,25.38,27.78,25.38,44s-11.37,22.75-25.38,14.65-25.39-27.77-25.38-44S304.55,29.44,318.55,37.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,44.85c10.52,6.07,19,20.84,19,33s-8.53,17.06-19,11-19-20.83-19-33S308,38.78,318.55,44.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,51.52c7.33,4.23,13.27,14.52,13.27,23s-5.94,11.89-13.27,7.66-13.27-14.52-13.27-23S311.22,47.29,318.55,51.52Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,51.52c7.33,4.23,13.27,14.52,13.27,23s-5.94,11.89-13.27,7.66-13.27-14.52-13.27-23S311.22,47.29,318.55,51.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,58.36a16.2,16.2,0,0,1,7.34,12.72c0,4.68-3.28,6.58-7.34,4.24a16.22,16.22,0,0,1-7.34-12.72C311.21,57.91,314.5,56,318.55,58.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,63.26a6.86,6.86,0,0,1,3.1,5.37c0,2-1.39,2.77-3.1,1.78a6.84,6.84,0,0,1-3.1-5.36C315.45,63.07,316.84,62.27,318.55,63.26Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,95.76s-.59,7.44-4,9.43-5.31-4-3.08-5.33Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,95.76s-6.74-3.21-10.18-1.23.84,6.62,3.07,5.33Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,95.76s-6.74-3.21-10.18-1.23.84,6.62,3.07,5.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.73 73.07 256.78 103.65 256.03 102.33 309.84 71.25 309.73 73.07",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,100.85a2.22,2.22,0,1,1-3,.81A2.22,2.22,0,0,1,257.7,100.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,73c-1.82,2.4,1.48,6.56,1.48,6.56l8.6-12.38Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,73c-1.82,2.4,1.48,6.56,1.48,6.56l8.6-12.38Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,68.39s2,4.94,4.94,4.57l10.08-5.82Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,68.39s2,4.94,4.94,4.57l10.08-5.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-2--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.92,395.34l-7.62-4.4a2.08,2.08,0,0,0-1.69-.08l-7.73,3.58a2.86,2.86,0,0,1-1.76.11,46.45,46.45,0,0,0-6-1.43A1.47,1.47,0,0,1,304,392l-1-5.1a1.19,1.19,0,0,0-1.13-.93H290.69a1.18,1.18,0,0,0-1.12.93l-1,5.1a1.47,1.47,0,0,1-1.12,1.08,46.45,46.45,0,0,0-6,1.43,2.86,2.86,0,0,1-1.76-.11L272,390.86a2.07,2.07,0,0,0-1.69.08l-7.62,4.4a.61.61,0,0,0-.36.52h0l0,6.61h0a.64.64,0,0,0,.31.51l3.5,2.52a1.66,1.66,0,0,1-.86.36l-10.16.65a1,1,0,0,0-1,1v4.32h0l0,8a1,1,0,0,0,.95,1l10.16.64a1.74,1.74,0,0,1,.88.37l-3.49,2.51a.65.65,0,0,0-.3.51h0l0,6.61h0a.62.62,0,0,0,.36.52l7.62,4.4a2,2,0,0,0,1.69.08l7.73-3.58a2.86,2.86,0,0,1,1.76-.11,46.45,46.45,0,0,0,6,1.43,1.47,1.47,0,0,1,1.12,1.08l1,5.1a1.2,1.2,0,0,0,1.13.93h11.21a1.2,1.2,0,0,0,1.13-.93l1-5.1a1.47,1.47,0,0,1,1.12-1.08,46.45,46.45,0,0,0,6-1.43,2.9,2.9,0,0,1,1.77.11l7.72,3.58a2,2,0,0,0,1.69-.08l7.63-4.4a.63.63,0,0,0,.35-.5h0l0-6.63h0a.65.65,0,0,0-.3-.51l-3.51-2.52a1.66,1.66,0,0,1,.86-.36l10.16-.64a1,1,0,0,0,.95-1V407.52a1,1,0,0,0-.95-1l-10.16-.65a1.74,1.74,0,0,1-.88-.37L330,403a.65.65,0,0,0,.3-.51h0l0-6.62h0A.61.61,0,0,0,329.92,395.34Zm-51.46,17.12c.55-1.82,2.18-3.61,5-5.22,7.11-4.1,18.64-4.1,25.76,0,2.61,1.51,4.31,3.17,5.08,4.86-.61,2.08-2.3,4.08-5.08,5.69-7.11,4.1-18.65,4.1-25.76,0A10.58,10.58,0,0,1,278.46,412.46Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,395.34l-7.62-4.4a2.08,2.08,0,0,0-1.69-.08l-7.73,3.58a2.86,2.86,0,0,1-1.76.11,46.45,46.45,0,0,0-6-1.43A1.47,1.47,0,0,1,304,392l-1-5.1a1.19,1.19,0,0,0-1.13-.93H290.69a1.18,1.18,0,0,0-1.12.93l-1,5.1a1.47,1.47,0,0,1-1.12,1.08,46.45,46.45,0,0,0-6,1.43,2.86,2.86,0,0,1-1.76-.11L272,390.86a2.07,2.07,0,0,0-1.69.08l-7.62,4.4a.61.61,0,0,0-.36.52h0l0,6.61h0a.64.64,0,0,0,.31.51l3.5,2.52a1.66,1.66,0,0,1-.86.36l-10.16.65a1,1,0,0,0-1,1v4.32h0l0,8a1,1,0,0,0,.95,1l10.16.64a1.74,1.74,0,0,1,.88.37l-3.49,2.51a.65.65,0,0,0-.3.51h0l0,6.61h0a.62.62,0,0,0,.36.52l7.62,4.4a2,2,0,0,0,1.69.08l7.73-3.58a2.86,2.86,0,0,1,1.76-.11,46.45,46.45,0,0,0,6,1.43,1.47,1.47,0,0,1,1.12,1.08l1,5.1a1.2,1.2,0,0,0,1.13.93h11.21a1.2,1.2,0,0,0,1.13-.93l1-5.1a1.47,1.47,0,0,1,1.12-1.08,46.45,46.45,0,0,0,6-1.43,2.9,2.9,0,0,1,1.77.11l7.72,3.58a2,2,0,0,0,1.69-.08l7.63-4.4a.63.63,0,0,0,.35-.5h0l0-6.63h0a.65.65,0,0,0-.3-.51l-3.51-2.52a1.66,1.66,0,0,1,.86-.36l10.16-.64a1,1,0,0,0,.95-1V407.52a1,1,0,0,0-.95-1l-10.16-.65a1.74,1.74,0,0,1-.88-.37L330,403a.65.65,0,0,0,.3-.51h0l0-6.62h0A.61.61,0,0,0,329.92,395.34Zm-51.46,17.12c.55-1.82,2.18-3.61,5-5.22,7.11-4.1,18.64-4.1,25.76,0,2.61,1.51,4.31,3.17,5.08,4.86-.61,2.08-2.3,4.08-5.08,5.69-7.11,4.1-18.65,4.1-25.76,0A10.58,10.58,0,0,1,278.46,412.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,415.75a1.87,1.87,0,0,0-1.37-.91l-10.16-.64a1,1,0,0,1-1-1v-1.35l0,8a1,1,0,0,0,.95,1l10.16.64a1.67,1.67,0,0,1,.89.36l2.55-1.83a.81.81,0,0,0,.11-1.24A15.32,15.32,0,0,1,266.62,415.75Zm-4.32-13.28h0a.64.64,0,0,0,.31.51l3.5,2.53a1.8,1.8,0,0,0,.51-.56,15.32,15.32,0,0,1,2.16-3,.81.81,0,0,0-.12-1.24l-6-4.35a.73.73,0,0,1-.3-.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18,402.92c-7.12-4.11-18.65-4.11-25.76,0-4.5,2.6-6.15,6.21-5,9.56.53-1.82,2.17-3.62,5-5.23,7.11-4.11,18.64-4.1,25.76,0,2.6,1.51,4.31,3.16,5.08,4.86C315.21,408.86,313.51,405.42,309.18,402.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.45,413.32a1,1,0,0,1-.94.88l-10.15.64a1.44,1.44,0,0,0-.52.14v6.61a1.64,1.64,0,0,1,.5-.14l10.16-.65a1,1,0,0,0,.95-1Zm-8.17-17.46h0a.34.34,0,0,1,0,.2.49.49,0,0,1-.13.2.74.74,0,0,1-.13.12l-6.05,4.35a.44.44,0,0,0-.14.13.73.73,0,0,0-.19.37.76.76,0,0,0,0,.26l0,.13a1.13,1.13,0,0,0,.2.35.63.63,0,0,1,.11.13A14.72,14.72,0,0,1,326,405a2,2,0,0,0,.48.54L330,403a.68.68,0,0,0,.3-.51h0Zm0,29a.67.67,0,0,1-.36.47l-7.62,4.39a2,2,0,0,1-1.19.21v6.6a1.92,1.92,0,0,0,1.18-.2l7.62-4.4a.59.59,0,0,0,.36-.5Zm-49.81,1.17a2.42,2.42,0,0,0-.76.19L272,429.84a1.7,1.7,0,0,1-.69.14l0,6.6a1.88,1.88,0,0,0,.69-.13l7.73-3.58a2.18,2.18,0,0,1,.76-.18Zm22.38,8.12a1.16,1.16,0,0,1-.94.5H290.69a1.1,1.1,0,0,1-.68-.24v6.61a1.13,1.13,0,0,0,.68.24h11.2a1.2,1.2,0,0,0,1-.56Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.45,413.32a1,1,0,0,1-.94.88l-10.15.64a1.44,1.44,0,0,0-.52.14v6.61a1.64,1.64,0,0,1,.5-.14l10.16-.65a1,1,0,0,0,.95-1Zm-8.17-17.46h0a.34.34,0,0,1,0,.2.49.49,0,0,1-.13.2.74.74,0,0,1-.13.12l-6.05,4.35a.44.44,0,0,0-.14.13.73.73,0,0,0-.19.37.76.76,0,0,0,0,.26l0,.13a1.13,1.13,0,0,0,.2.35.63.63,0,0,1,.11.13A14.72,14.72,0,0,1,326,405a2,2,0,0,0,.48.54L330,403a.68.68,0,0,0,.3-.51h0Zm0,29a.67.67,0,0,1-.36.47l-7.62,4.39a2,2,0,0,1-1.19.21v6.6a1.92,1.92,0,0,0,1.18-.2l7.62-4.4a.59.59,0,0,0,.36-.5Zm-49.81,1.17a2.42,2.42,0,0,0-.76.19L272,429.84a1.7,1.7,0,0,1-.69.14l0,6.6a1.88,1.88,0,0,0,.69-.13l7.73-3.58a2.18,2.18,0,0,1,.76-.18Zm22.38,8.12a1.16,1.16,0,0,1-.94.5H290.69a1.1,1.1,0,0,1-.68-.24v6.61a1.13,1.13,0,0,0,.68.24h11.2a1.2,1.2,0,0,0,1-.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,390.86l-7.73,3.58a2.86,2.86,0,0,1-1.76.11,46.45,46.45,0,0,0-6-1.43A1.47,1.47,0,0,1,304,392l-1-5.1a1.19,1.19,0,0,0-1.13-.93H290.69a1.18,1.18,0,0,0-1.12.93l-1,5.1a1.47,1.47,0,0,1-1.12,1.08,46.45,46.45,0,0,0-6,1.43,2.86,2.86,0,0,1-1.76-.11L272,390.86a2.07,2.07,0,0,0-1.69.08l-7.62,4.4a.57.57,0,0,0-.06,1l6.05,4.35a.81.81,0,0,1,.11,1.24,15.44,15.44,0,0,0-2.16,3,1.87,1.87,0,0,1-1.37.91l-10.16.65a1,1,0,0,0-1,1v5.67a1,1,0,0,0,1,1l10.16.64a1.87,1.87,0,0,1,1.37.91,15.14,15.14,0,0,0,2.16,3,.81.81,0,0,1-.11,1.24l-6.05,4.35a.57.57,0,0,0,.06,1l7.62,4.4a2,2,0,0,0,1.69.08l7.72-3.58a2.9,2.9,0,0,1,1.77-.11,44.85,44.85,0,0,0,6,1.43,1.47,1.47,0,0,1,1.12,1.09l1,5.09a1.18,1.18,0,0,0,1.12.93H301.9a1.19,1.19,0,0,0,1.13-.93l1-5.09a1.47,1.47,0,0,1,1.12-1.09,44.85,44.85,0,0,0,6-1.43,2.86,2.86,0,0,1,1.76.11l7.73,3.58a2,2,0,0,0,1.69-.08l7.62-4.4a.57.57,0,0,0,.06-1L323.93,420a.81.81,0,0,1-.11-1.24,15.14,15.14,0,0,0,2.16-3,1.87,1.87,0,0,1,1.37-.91l10.16-.64a1,1,0,0,0,.95-1v-5.67a1,1,0,0,0-.95-1l-10.16-.65A1.87,1.87,0,0,1,326,405a15.44,15.44,0,0,0-2.16-3,.81.81,0,0,1,.11-1.24l6.05-4.35a.57.57,0,0,0-.06-1l-7.62-4.4A2.08,2.08,0,0,0,320.61,390.86Zm-11.43,12.06c7.11,4.1,7.11,10.76,0,14.87s-18.65,4.1-25.76,0-7.11-10.77,0-14.88S302.07,398.81,309.18,402.92Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.61,390.86l-7.73,3.58a2.86,2.86,0,0,1-1.76.11,46.45,46.45,0,0,0-6-1.43A1.47,1.47,0,0,1,304,392l-1-5.1a1.19,1.19,0,0,0-1.13-.93H290.69a1.18,1.18,0,0,0-1.12.93l-1,5.1a1.47,1.47,0,0,1-1.12,1.08,46.45,46.45,0,0,0-6,1.43,2.86,2.86,0,0,1-1.76-.11L272,390.86a2.07,2.07,0,0,0-1.69.08l-7.62,4.4a.57.57,0,0,0-.06,1l6.05,4.35a.81.81,0,0,1,.11,1.24,15.44,15.44,0,0,0-2.16,3,1.87,1.87,0,0,1-1.37.91l-10.16.65a1,1,0,0,0-1,1v5.67a1,1,0,0,0,1,1l10.16.64a1.87,1.87,0,0,1,1.37.91,15.14,15.14,0,0,0,2.16,3,.81.81,0,0,1-.11,1.24l-6.05,4.35a.57.57,0,0,0,.06,1l7.62,4.4a2,2,0,0,0,1.69.08l7.72-3.58a2.9,2.9,0,0,1,1.77-.11,44.85,44.85,0,0,0,6,1.43,1.47,1.47,0,0,1,1.12,1.09l1,5.09a1.18,1.18,0,0,0,1.12.93H301.9a1.19,1.19,0,0,0,1.13-.93l1-5.09a1.47,1.47,0,0,1,1.12-1.09,44.85,44.85,0,0,0,6-1.43,2.86,2.86,0,0,1,1.76.11l7.73,3.58a2,2,0,0,0,1.69-.08l7.62-4.4a.57.57,0,0,0,.06-1L323.93,420a.81.81,0,0,1-.11-1.24,15.14,15.14,0,0,0,2.16-3,1.87,1.87,0,0,1,1.37-.91l10.16-.64a1,1,0,0,0,.95-1v-5.67a1,1,0,0,0-.95-1l-10.16-.65A1.87,1.87,0,0,1,326,405a15.44,15.44,0,0,0-2.16-3,.81.81,0,0,1,.11-1.24l6.05-4.35a.57.57,0,0,0-.06-1l-7.62-4.4A2.08,2.08,0,0,0,320.61,390.86Zm-11.43,12.06c7.11,4.1,7.11,10.76,0,14.87s-18.65,4.1-25.76,0-7.11-10.77,0-14.88S302.07,398.81,309.18,402.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,435.07H290.69a1.57,1.57,0,0,1-1.49-1.24l-1-5.09a1.1,1.1,0,0,0-.81-.79,46.5,46.5,0,0,1-6.05-1.44,2.48,2.48,0,0,0-1.5.09l-7.73,3.58a2.44,2.44,0,0,1-2-.09l-7.62-4.4a1,1,0,0,1-.54-.81,1,1,0,0,1,.46-.85l6-4.35a.43.43,0,0,0,.19-.31.43.43,0,0,0-.14-.37,16,16,0,0,1-2.21-3.07,1.52,1.52,0,0,0-1.07-.72l-10.16-.64a1.42,1.42,0,0,1-1.3-1.38v-5.67a1.41,1.41,0,0,1,1.3-1.39l10.15-.64a1.47,1.47,0,0,0,1.07-.72,15.67,15.67,0,0,1,2.21-3.06.46.46,0,0,0,.14-.38.43.43,0,0,0-.19-.31l-6-4.35a.93.93,0,0,1,.08-1.65l7.62-4.41a2.44,2.44,0,0,1,2-.09l7.73,3.58a2.48,2.48,0,0,0,1.5.09,46.12,46.12,0,0,1,6.05-1.44,1.1,1.1,0,0,0,.81-.78l1-5.09a1.56,1.56,0,0,1,1.5-1.24h11.2a1.56,1.56,0,0,1,1.5,1.24l1,5.09a1.07,1.07,0,0,0,.81.78,46.5,46.5,0,0,1,6.05,1.44,2.48,2.48,0,0,0,1.5-.09l7.73-3.58a2.44,2.44,0,0,1,2,.09l7.62,4.41a.93.93,0,0,1,.08,1.65l-6,4.35a.43.43,0,0,0-.19.31.46.46,0,0,0,.14.38,15.67,15.67,0,0,1,2.21,3.06,1.45,1.45,0,0,0,1.07.72l10.15.64a1.41,1.41,0,0,1,1.3,1.39v5.67a1.41,1.41,0,0,1-1.3,1.38l-10.16.64a1.53,1.53,0,0,0-1.06.72A16,16,0,0,1,324.1,419a.43.43,0,0,0-.14.37.43.43,0,0,0,.19.31l6,4.35a1,1,0,0,1,.46.85,1,1,0,0,1-.54.81l-7.62,4.4a2.44,2.44,0,0,1-2,.09l-7.73-3.58a2.48,2.48,0,0,0-1.5-.09,46.9,46.9,0,0,1-6.05,1.44,1.07,1.07,0,0,0-.81.78l-1,5.1A1.57,1.57,0,0,1,301.9,435.07Zm-21.13-9.39a2.62,2.62,0,0,1,.82.12,46.61,46.61,0,0,0,6,1.41A1.85,1.85,0,0,1,289,428.6l1,5.09a.83.83,0,0,0,.76.63H301.9a.83.83,0,0,0,.77-.63l1-5.09a1.85,1.85,0,0,1,1.42-1.39A46.61,46.61,0,0,0,311,425.8a3.16,3.16,0,0,1,2,.12l7.73,3.58a1.69,1.69,0,0,0,1.34-.06l7.63-4.4a.31.31,0,0,0,.17-.2.33.33,0,0,0-.15-.21l-6.05-4.34a1.2,1.2,0,0,1-.5-.85,1.23,1.23,0,0,1,.34-.95,15.33,15.33,0,0,0,2.1-2.92,2.23,2.23,0,0,1,1.68-1.1l10.16-.65a.66.66,0,0,0,.6-.63v-5.67a.66.66,0,0,0-.6-.64l-10.16-.64a2.25,2.25,0,0,1-1.68-1.11,15,15,0,0,0-2.11-2.92,1.26,1.26,0,0,1-.33-.95,1.24,1.24,0,0,1,.5-.85l6.05-4.34a.33.33,0,0,0,.15-.21.34.34,0,0,0-.17-.2l-7.63-4.4a1.69,1.69,0,0,0-1.34-.06L313,394.78a3.21,3.21,0,0,1-2,.13,45.13,45.13,0,0,0-6-1.42,1.84,1.84,0,0,1-1.42-1.38l-1-5.1a.83.83,0,0,0-.77-.63H290.7a.83.83,0,0,0-.77.63l-1,5.1a1.84,1.84,0,0,1-1.43,1.38,45,45,0,0,0-6,1.42,3.21,3.21,0,0,1-2-.13l-7.73-3.58a1.69,1.69,0,0,0-1.34.06l-7.63,4.4a.34.34,0,0,0-.17.2.33.33,0,0,0,.15.21l6,4.35a1.18,1.18,0,0,1,.51.84,1.23,1.23,0,0,1-.34.95,15.33,15.33,0,0,0-2.1,2.92,2.25,2.25,0,0,1-1.68,1.11l-10.16.64a.66.66,0,0,0-.6.64v5.67a.66.66,0,0,0,.6.63l10.16.65a2.23,2.23,0,0,1,1.68,1.1,14.9,14.9,0,0,0,2.1,2.92,1.24,1.24,0,0,1,.34,1,1.22,1.22,0,0,1-.51.84l-6,4.34a.33.33,0,0,0-.15.21.31.31,0,0,0,.17.2l7.63,4.4a1.69,1.69,0,0,0,1.34.06l7.73-3.58A3.07,3.07,0,0,1,280.77,425.68Zm15.53-4.45a26.73,26.73,0,0,1-13.07-3.12c-3.56-2.05-5.52-4.81-5.52-7.76s2-5.7,5.52-7.76c7.21-4.16,18.93-4.16,26.14,0h0c3.56,2.06,5.52,4.81,5.52,7.76s-2,5.71-5.52,7.76A26.76,26.76,0,0,1,296.3,421.23Zm0-21a25.94,25.94,0,0,0-12.69,3c-3.32,1.92-5.15,4.44-5.15,7.11s1.83,5.2,5.15,7.11c7,4,18.38,4,25.38,0,3.32-1.91,5.15-4.44,5.15-7.11s-1.83-5.19-5.15-7.11h0A25.94,25.94,0,0,0,296.3,400.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,425.19a1.53,1.53,0,0,1-1-1.59l.32-2.67a1.22,1.22,0,0,0-1.09-1.37l-7-.73a2,2,0,0,0-1.81,1l-1.4,2.73a2.5,2.5,0,0,1-1.82,1.19,36.55,36.55,0,0,0-3.64.45,3.53,3.53,0,0,1-2.27-.46l-3.78-2.51a2.72,2.72,0,0,0-2.21-.23l-5.62,2.26a.83.83,0,0,0-.58.72h0V424h0v5.74h0a.91.91,0,0,0,.27.63l.33.35a3,3,0,0,1-1.55.48l-6.42-.26a1.73,1.73,0,0,0-1.63,1.14l-1,3.11a1.26,1.26,0,0,0,0,.38h0v5.8h0a1.06,1.06,0,0,0,.91,1l5,.85-1.94,1a.81.81,0,0,0-.51.7h0v5.81h0a.93.93,0,0,0,.35.65l3.59,3a2.58,2.58,0,0,0,2.15.43l5.47-1.72a3.87,3.87,0,0,1,2.33.16,30.62,30.62,0,0,0,2.93,1.08,1.41,1.41,0,0,1,.72.5v3.92h0a1.21,1.21,0,0,0,1.09,1.2l7,.74a2,2,0,0,0,1.81-1l1.4-2.73a2.46,2.46,0,0,1,1.82-1.19,36.18,36.18,0,0,0,3.64-.45,3.57,3.57,0,0,1,2.27.45l3.79,2.52a2.65,2.65,0,0,0,2.2.22l5.62-2.25a.8.8,0,0,0,.58-.75h0v-5.8h0a.94.94,0,0,0-.28-.62l-.33-.35a3,3,0,0,1,1.55-.48l6.42.26a1.73,1.73,0,0,0,1.63-1.14l1-3.11a1.1,1.1,0,0,0,.05-.35h0v-5.78h0a1,1,0,0,0-.9-1.07l-5-.86,1.94-1a.78.78,0,0,0,.51-.71h0v-5.77h0a.83.83,0,0,0-.35-.67l-3.59-3a2.51,2.51,0,0,0-2.15-.43l-5.47,1.71a3.8,3.8,0,0,1-2.33-.15A30.62,30.62,0,0,0,237.07,425.19Zm-23.32,14.56a10.37,10.37,0,0,1,4.79-3.47c6.1-2.45,14.47-1.57,18.7,2a8.3,8.3,0,0,1,1.43,1.51,10.46,10.46,0,0,1-4.81,3.49c-6.1,2.44-14.47,1.57-18.7-2A7.66,7.66,0,0,1,213.75,439.75Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,425.19a1.53,1.53,0,0,1-1-1.59l.32-2.67a1.22,1.22,0,0,0-1.09-1.37l-7-.73a2,2,0,0,0-1.81,1l-1.4,2.73a2.5,2.5,0,0,1-1.82,1.19,36.55,36.55,0,0,0-3.64.45,3.53,3.53,0,0,1-2.27-.46l-3.78-2.51a2.72,2.72,0,0,0-2.21-.23l-5.62,2.26a.83.83,0,0,0-.58.72h0V424h0v5.74h0a.91.91,0,0,0,.27.63l.33.35a3,3,0,0,1-1.55.48l-6.42-.26a1.73,1.73,0,0,0-1.63,1.14l-1,3.11a1.26,1.26,0,0,0,0,.38h0v5.8h0a1.06,1.06,0,0,0,.91,1l5,.85-1.94,1a.81.81,0,0,0-.51.7h0v5.81h0a.93.93,0,0,0,.35.65l3.59,3a2.58,2.58,0,0,0,2.15.43l5.47-1.72a3.87,3.87,0,0,1,2.33.16,30.62,30.62,0,0,0,2.93,1.08,1.41,1.41,0,0,1,.72.5v3.92h0a1.21,1.21,0,0,0,1.09,1.2l7,.74a2,2,0,0,0,1.81-1l1.4-2.73a2.46,2.46,0,0,1,1.82-1.19,36.18,36.18,0,0,0,3.64-.45,3.57,3.57,0,0,1,2.27.45l3.79,2.52a2.65,2.65,0,0,0,2.2.22l5.62-2.25a.8.8,0,0,0,.58-.75h0v-5.8h0a.94.94,0,0,0-.28-.62l-.33-.35a3,3,0,0,1,1.55-.48l6.42.26a1.73,1.73,0,0,0,1.63-1.14l1-3.11a1.1,1.1,0,0,0,.05-.35h0v-5.78h0a1,1,0,0,0-.9-1.07l-5-.86,1.94-1a.78.78,0,0,0,.51-.71h0v-5.77h0a.83.83,0,0,0-.35-.67l-3.59-3a2.51,2.51,0,0,0-2.15-.43l-5.47,1.71a3.8,3.8,0,0,1-2.33-.15A30.62,30.62,0,0,0,237.07,425.19Zm-23.32,14.56a10.37,10.37,0,0,1,4.79-3.47c6.1-2.45,14.47-1.57,18.7,2a8.3,8.3,0,0,1,1.43,1.51,10.46,10.46,0,0,1-4.81,3.49c-6.1,2.44-14.47,1.57-18.7-2A7.66,7.66,0,0,1,213.75,439.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,439.1a2.1,2.1,0,0,0-1.5-1.43L196,436.62a1.05,1.05,0,0,1-.91-.95v5.73a1.06,1.06,0,0,0,.9,1l5,.86,2.58-1.3a1.22,1.22,0,0,0,.51-1.66A7.09,7.09,0,0,1,203.59,439.1Zm1.49-9.33h0a.94.94,0,0,0,.27.63l.33.35a2.26,2.26,0,0,0,.53-.41,14.84,14.84,0,0,1,1.54-1.37,1.08,1.08,0,0,0,.16-1.64l-2.56-2.72a.86.86,0,0,1-.27-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.55,430.49c-5.26,2.11-7.12,6-4.8,9.27a10.38,10.38,0,0,1,4.79-3.48c6.1-2.44,14.47-1.57,18.7,2a7.89,7.89,0,0,1,1.42,1.51c1.63-2.33,1.25-5.08-1.42-7.3C233,428.92,224.64,428.05,218.55,430.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,450.5a2,2,0,0,0-.58.68l-1.4,2.73a2,2,0,0,1-1,.87v5.78a1.92,1.92,0,0,0,1-.86L227.4,457a2.09,2.09,0,0,1,.6-.67Zm19.34-.76h0a.8.8,0,0,1-.58.75l-5.62,2.26a2.51,2.51,0,0,1-1.47.05v5.79a2.63,2.63,0,0,0,1.48-.06l5.63-2.25a.83.83,0,0,0,.58-.75ZM210,447.31l-5.39,1.7a2.43,2.43,0,0,1-1.36,0v5.78a2.44,2.44,0,0,0,1.36,0l5.41-1.7Zm47.34-9.15a2.21,2.21,0,0,1-.06.34l-1,3.11a1.72,1.72,0,0,1-1.62,1.14l-6.43-.26a2.5,2.5,0,0,0-1,.21v5.78a2.66,2.66,0,0,1,1-.2l6.43.26a1.74,1.74,0,0,0,1.62-1.14l1-3.11a1.1,1.1,0,0,0,.05-.35Zm-3.43-9.37a.84.84,0,0,1,0,.2.67.67,0,0,1-.19.29,1.24,1.24,0,0,1-.29.2l-4.51,2.27a.71.71,0,0,0-.27.2,1,1,0,0,0-.31.47,1.09,1.09,0,0,0-.06.45,2,2,0,0,0,0,.23,2.33,2.33,0,0,0,.11.31,9.84,9.84,0,0,1,.46,1.2,2.1,2.1,0,0,0,1.49,1.45l1.13.18,1.94-1a.82.82,0,0,0,.51-.72h0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,450.5a2,2,0,0,0-.58.68l-1.4,2.73a2,2,0,0,1-1,.87v5.78a1.92,1.92,0,0,0,1-.86L227.4,457a2.09,2.09,0,0,1,.6-.67Zm19.34-.76h0a.8.8,0,0,1-.58.75l-5.62,2.26a2.51,2.51,0,0,1-1.47.05v5.79a2.63,2.63,0,0,0,1.48-.06l5.63-2.25a.83.83,0,0,0,.58-.75ZM210,447.31l-5.39,1.7a2.43,2.43,0,0,1-1.36,0v5.78a2.44,2.44,0,0,0,1.36,0l5.41-1.7Zm47.34-9.15a2.21,2.21,0,0,1-.06.34l-1,3.11a1.72,1.72,0,0,1-1.62,1.14l-6.43-.26a2.5,2.5,0,0,0-1,.21v5.78a2.66,2.66,0,0,1,1-.2l6.43.26a1.74,1.74,0,0,0,1.62-1.14l1-3.11a1.1,1.1,0,0,0,.05-.35Zm-3.43-9.37a.84.84,0,0,1,0,.2.67.67,0,0,1-.19.29,1.24,1.24,0,0,1-.29.2l-4.51,2.27a.71.71,0,0,0-.27.2,1,1,0,0,0-.31.47,1.09,1.09,0,0,0-.06.45,2,2,0,0,0,0,.23,2.33,2.33,0,0,0,.11.31,9.84,9.84,0,0,1,.46,1.2,2.1,2.1,0,0,0,1.49,1.45l1.13.18,1.94-1a.82.82,0,0,0,.51-.72h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,424.71l-5.47,1.71a3.8,3.8,0,0,1-2.33-.15,30.62,30.62,0,0,0-2.93-1.08,1.53,1.53,0,0,1-1-1.59l.32-2.67a1.22,1.22,0,0,0-1.09-1.37l-7-.73a2,2,0,0,0-1.81,1l-1.4,2.73a2.5,2.5,0,0,1-1.82,1.19,36.55,36.55,0,0,0-3.64.45,3.53,3.53,0,0,1-2.27-.46l-3.78-2.51a2.72,2.72,0,0,0-2.21-.23l-5.62,2.26a.79.79,0,0,0-.3,1.37l2.55,2.72a1.08,1.08,0,0,1-.16,1.64,14.84,14.84,0,0,0-1.54,1.37,3.1,3.1,0,0,1-2.08.89l-6.42-.26a1.73,1.73,0,0,0-1.63,1.14l-1,3.11a1.06,1.06,0,0,0,.86,1.4l6.11,1.05a2.07,2.07,0,0,1,1.49,1.43,10.1,10.1,0,0,0,.46,1.22,1.21,1.21,0,0,1-.51,1.65L199,444.24a.76.76,0,0,0-.16,1.36l3.59,3a2.51,2.51,0,0,0,2.15.43l5.47-1.71a3.79,3.79,0,0,1,2.33.15c.93.4,1.92.76,2.93,1.08a1.52,1.52,0,0,1,1,1.59l-.32,2.66a1.24,1.24,0,0,0,1.09,1.38l7,.73a2,2,0,0,0,1.82-1l1.4-2.73a2.48,2.48,0,0,1,1.82-1.19c1.22-.09,2.44-.24,3.64-.45a3.54,3.54,0,0,1,2.27.46l3.78,2.51a2.65,2.65,0,0,0,2.2.22l5.62-2.25a.79.79,0,0,0,.31-1.37l-2.55-2.72a1.08,1.08,0,0,1,.15-1.64,14.84,14.84,0,0,0,1.54-1.37,3.1,3.1,0,0,1,2.08-.89l6.43.26a1.71,1.71,0,0,0,1.62-1.14l1-3.11a1.06,1.06,0,0,0-.86-1.4l-6.11-1.05a2.09,2.09,0,0,1-1.49-1.43,8.66,8.66,0,0,0-.46-1.22,1.22,1.22,0,0,1,.51-1.65l4.52-2.27a.76.76,0,0,0,.15-1.36l-3.59-3A2.51,2.51,0,0,0,247.8,424.71Zm-10.56,7.73c4.23,3.52,2.71,8.35-3.38,10.79s-14.47,1.57-18.7-2-2.71-8.35,3.39-10.79S233,428.92,237.24,432.44Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.8,424.71l-5.47,1.71a3.8,3.8,0,0,1-2.33-.15,30.62,30.62,0,0,0-2.93-1.08,1.53,1.53,0,0,1-1-1.59l.32-2.67a1.22,1.22,0,0,0-1.09-1.37l-7-.73a2,2,0,0,0-1.81,1l-1.4,2.73a2.5,2.5,0,0,1-1.82,1.19,36.55,36.55,0,0,0-3.64.45,3.53,3.53,0,0,1-2.27-.46l-3.78-2.51a2.72,2.72,0,0,0-2.21-.23l-5.62,2.26a.79.79,0,0,0-.3,1.37l2.55,2.72a1.08,1.08,0,0,1-.16,1.64,14.84,14.84,0,0,0-1.54,1.37,3.1,3.1,0,0,1-2.08.89l-6.42-.26a1.73,1.73,0,0,0-1.63,1.14l-1,3.11a1.06,1.06,0,0,0,.86,1.4l6.11,1.05a2.07,2.07,0,0,1,1.49,1.43,10.1,10.1,0,0,0,.46,1.22,1.21,1.21,0,0,1-.51,1.65L199,444.24a.76.76,0,0,0-.16,1.36l3.59,3a2.51,2.51,0,0,0,2.15.43l5.47-1.71a3.79,3.79,0,0,1,2.33.15c.93.4,1.92.76,2.93,1.08a1.52,1.52,0,0,1,1,1.59l-.32,2.66a1.24,1.24,0,0,0,1.09,1.38l7,.73a2,2,0,0,0,1.82-1l1.4-2.73a2.48,2.48,0,0,1,1.82-1.19c1.22-.09,2.44-.24,3.64-.45a3.54,3.54,0,0,1,2.27.46l3.78,2.51a2.65,2.65,0,0,0,2.2.22l5.62-2.25a.79.79,0,0,0,.31-1.37l-2.55-2.72a1.08,1.08,0,0,1,.15-1.64,14.84,14.84,0,0,0,1.54-1.37,3.1,3.1,0,0,1,2.08-.89l6.43.26a1.71,1.71,0,0,0,1.62-1.14l1-3.11a1.06,1.06,0,0,0-.86-1.4l-6.11-1.05a2.09,2.09,0,0,1-1.49-1.43,8.66,8.66,0,0,0-.46-1.22,1.22,1.22,0,0,1,.51-1.65l4.52-2.27a.76.76,0,0,0,.15-1.36l-3.59-3A2.51,2.51,0,0,0,247.8,424.71Zm-10.56,7.73c4.23,3.52,2.71,8.35-3.38,10.79s-14.47,1.57-18.7-2-2.71-8.35,3.39-10.79S233,428.92,237.24,432.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.33,455.39h-.2l-7-.74a1.69,1.69,0,0,1-1.17-.63,1.79,1.79,0,0,1-.36-1.28l.33-2.67a1.06,1.06,0,0,0-.71-1.06,28.27,28.27,0,0,1-3-1.1,3.33,3.33,0,0,0-2-.13l-5.47,1.71a3,3,0,0,1-2.61-.52l-3.59-3a1.24,1.24,0,0,1,.25-2.18l4.51-2.27a.74.74,0,0,0,.29-1,9.09,9.09,0,0,1-.49-1.28,1.62,1.62,0,0,0-1.1-1.09l-6.11-1a1.56,1.56,0,0,1-1.25-2l1-3.11a2.16,2.16,0,0,1,2.11-1.48l6.42.26a2.74,2.74,0,0,0,1.71-.74,15.72,15.72,0,0,1,1.59-1.42.64.64,0,0,0,.27-.47.62.62,0,0,0-.17-.45L205,425a1.28,1.28,0,0,1,.48-2.17l5.62-2.25a3.15,3.15,0,0,1,2.66.27l3.78,2.51a3,3,0,0,0,1.91.38,36.82,36.82,0,0,1,3.69-.45,2,2,0,0,0,1.42-.93l1.4-2.72a2.48,2.48,0,0,1,2.3-1.25l7,.73a1.74,1.74,0,0,1,1.17.64,1.69,1.69,0,0,1,.36,1.28l-.32,2.67a1,1,0,0,0,.71,1.06,28.27,28.27,0,0,1,3,1.1,3.29,3.29,0,0,0,2,.13l5.47-1.71a3.07,3.07,0,0,1,2.62.52l3.59,3a1.34,1.34,0,0,1,.52,1.17,1.32,1.32,0,0,1-.77,1l-4.52,2.27a.74.74,0,0,0-.29,1,9.09,9.09,0,0,1,.49,1.28,1.62,1.62,0,0,0,1.1,1.09l6.12,1a1.54,1.54,0,0,1,1.09.73,1.58,1.58,0,0,1,.15,1.31l-1,3.11a2.19,2.19,0,0,1-2.11,1.48l-6.43-.26a2.67,2.67,0,0,0-1.71.74,15.59,15.59,0,0,1-1.58,1.42.62.62,0,0,0-.28.46.63.63,0,0,0,.17.46l2.56,2.71a1.29,1.29,0,0,1-.48,2.17l-5.63,2.25a3.13,3.13,0,0,1-2.65-.27l-3.79-2.51a3,3,0,0,0-1.91-.38,36.82,36.82,0,0,1-3.69.45,2,2,0,0,0-1.42.92l-1.4,2.73A2.48,2.48,0,0,1,224.33,455.39ZM211,446.69a4.17,4.17,0,0,1,1.64.31,27.78,27.78,0,0,0,2.88,1.06,2,2,0,0,1,1.39,2.11l-.32,2.67a.72.72,0,0,0,.15.55.73.73,0,0,0,.5.28l7,.73a1.48,1.48,0,0,0,1.33-.72L227,451a2.92,2.92,0,0,1,2.22-1.46c1.21-.09,2.42-.24,3.59-.44a4,4,0,0,1,2.63.53l3.78,2.51a2.19,2.19,0,0,0,1.75.18l5.62-2.25c.15-.07.25-.15.27-.25a.43.43,0,0,0-.14-.34l-2.55-2.71a1.57,1.57,0,0,1-.44-1.2,1.68,1.68,0,0,1,.65-1.17,14.82,14.82,0,0,0,1.49-1.33,3.59,3.59,0,0,1,2.45-1l6.43.26a1.25,1.25,0,0,0,1.13-.8l1-3.11a.56.56,0,0,0-.47-.77l-6.11-1a2.58,2.58,0,0,1-1.88-1.78,8.49,8.49,0,0,0-.44-1.15,1.71,1.71,0,0,1,.74-2.3l4.52-2.27c.14-.07.23-.16.24-.24a.39.39,0,0,0-.18-.3l-3.59-3a2.08,2.08,0,0,0-1.69-.33l-5.47,1.71a4.23,4.23,0,0,1-2.67-.17,29.59,29.59,0,0,0-2.88-1.06,2,2,0,0,1-1.4-2.12l.32-2.66a.74.74,0,0,0-.65-.83l-7-.73a1.49,1.49,0,0,0-1.33.72l-1.4,2.72a2.92,2.92,0,0,1-2.22,1.46c-1.21.09-2.42.24-3.59.44a4.07,4.07,0,0,1-2.63-.53l-3.78-2.51a2.16,2.16,0,0,0-1.74-.18l-5.63,2.25a.4.4,0,0,0-.27.25.43.43,0,0,0,.14.34l2.55,2.71a1.53,1.53,0,0,1,.44,1.2,1.61,1.61,0,0,1-.65,1.17,14.82,14.82,0,0,0-1.49,1.33,3.62,3.62,0,0,1-2.45,1l-6.42-.26a1.24,1.24,0,0,0-1.14.8l-1,3.11a.58.58,0,0,0,0,.5.59.59,0,0,0,.42.27l6.11,1a2.58,2.58,0,0,1,1.88,1.78,8.49,8.49,0,0,0,.44,1.15,1.7,1.7,0,0,1-.74,2.3l-4.51,2.27c-.14.07-.23.16-.24.24a.37.37,0,0,0,.18.3l3.58,3a2.1,2.1,0,0,0,1.7.33l5.47-1.71A3.25,3.25,0,0,1,211,446.69Zm15.28-1.59c-4.38,0-8.7-1.2-11.39-3.44-1.93-1.61-2.83-3.59-2.51-5.58.39-2.47,2.58-4.67,6-6.05,6.24-2.49,14.85-1.58,19.19,2,1.94,1.61,2.83,3.59,2.51,5.58-.39,2.46-2.58,4.67-6,6.05A21.3,21.3,0,0,1,226.24,445.1Zm0-15.51a20.42,20.42,0,0,0-7.47,1.35c-3.11,1.25-5.09,3.18-5.42,5.3-.26,1.65.49,3.26,2.17,4.66,4.1,3.41,12.26,4.25,18.19,1.87,3.11-1.24,5.09-3.17,5.42-5.29.26-1.65-.49-3.26-2.17-4.66C234.4,430.72,230.34,429.59,226.2,429.59Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-1--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.12,159.75h.21l.46,0a6,6,0,0,0,.73-.07l.64-.1.28-.07.4-.1a20.36,20.36,0,0,0,9.27-6c7.31-7.72,10.79-19.4,7.76-26.09a7.18,7.18,0,0,0-5.61-4.44,2.4,2.4,0,0,0-.28,0l-.26,0h-.31a11.45,11.45,0,0,0-5.06,1.07q.09.93.09,2c0,9.14-6.41,20.25-14.33,24.82-.58.33-1.15.63-1.69.88a12,12,0,0,0,1,3.74A7.16,7.16,0,0,0,182.12,159.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,168.05c-.26-.39-.94-.37-1.53,0s-1.44.95-2.15,1.36l7.51,4.36v0a.46.46,0,0,1-.18-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,183.49l2.25-10.22a1.16,1.16,0,0,0-.73-1.28,11.25,11.25,0,0,1-3.12-1.81,1.29,1.29,0,0,0-1.59.27l-7.29,6.67a1.31,1.31,0,0,1-.8.37l11.58,6.7A.64.64,0,0,1,171.38,183.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,131.17l6.12.35a1.19,1.19,0,0,1,.45.11c-.42-.24-4-2.31-7.46-4.31,0,.93-.05,1.89-.14,2.86A1,1,0,0,0,214,131.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.84,177.43a.54.54,0,0,0,.25.06l-.21-.13A.21.21,0,0,1,159.84,177.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.61,177.19,156.37,170a1.85,1.85,0,0,1,.42-1.7l6.82-8.28a2.85,2.85,0,0,0,.67-1.8,32.31,32.31,0,0,1,0-5.9,1,1,0,0,0-1-1l-6.12-.34c-.62,0-1-.5-.83-1l3.37-11.35a2.22,2.22,0,0,1,1.51-1.26l6.71-1.62a2.86,2.86,0,0,0,1.7-1.27,59.33,59.33,0,0,1,3.6-6.25,2.51,2.51,0,0,0,.4-1.77l-2.18-7.39a2.06,2.06,0,0,1,.6-1.72l7.84-8.27c.47-.49,1-.57,1.32-.18l3.64,5.58c.26.39.93.36,1.53,0a32.17,32.17,0,0,1,4.42-2.56,3.35,3.35,0,0,0,1.56-1.5L196.2,100a1.93,1.93,0,0,1,1.56-1.09l7.13-.71a1.21,1.21,0,0,1,.68.12.63.63,0,0,1,.31.72l-2.25,10.2a1.16,1.16,0,0,0,.73,1.28,11.39,11.39,0,0,1,3.12,1.82,1.29,1.29,0,0,0,1.59-.27l7.3-6.66a1,1,0,0,1,1-.33L203,96.75a.57.57,0,0,0-.27-.06c-4.14-2.39-11.4-6.59-11.57-6.7a1.21,1.21,0,0,0-.71-.13l-7.13.7a2,2,0,0,0-1.56,1.09L177.92,102a3.36,3.36,0,0,1-1.56,1.51c-.75.35-1.51.75-2.27,1.19l-7.48-4.33c-.3-.2-.77-.07-1.16.34L157.62,109a2.09,2.09,0,0,0-.61,1.72l2.18,7.38a2.47,2.47,0,0,1-.4,1.78,59.2,59.2,0,0,0-3.6,6.26,2.85,2.85,0,0,1-1.7,1.26l-6.7,1.61a2.23,2.23,0,0,0-1.52,1.27l-3.37,11.35a.73.73,0,0,0,.25.82c.15.12,7.59,4.41,7.59,4.41,0,1,0,2,.13,3a2.91,2.91,0,0,1-.66,1.8L142.37,160a1.85,1.85,0,0,0-.41,1.7l3.25,7.18a.57.57,0,0,0,.2.23l14.4,8.33A.54.54,0,0,1,159.61,177.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.18,90a1.08,1.08,0,0,0-.7-.15l-7.14.72a2.1,2.1,0,0,0-1.19.56l14.43,8.32a2,2,0,0,1,1.17-.54l7.14-.71a1.21,1.21,0,0,1,.66.1ZM166.6,100.39c-.29-.19-.76-.07-1.15.34L157.61,109a2.45,2.45,0,0,0-.55,1l14.42,8.27a2.53,2.53,0,0,1,.55-.91l7.83-8.27a1,1,0,0,1,1.1-.37Zm-6.93,38.23a1.31,1.31,0,0,1,.28-.48l-14.44-8.31a1.48,1.48,0,0,0-.24.44l-3.37,11.36a.73.73,0,0,0,.25.82l.13.09,7.42,4.29.05,0,6.89,4a.74.74,0,0,1-.34-.87Zm-.06,38.57L156.37,170a1.26,1.26,0,0,1,0-.86l-14.43-8.33a1.31,1.31,0,0,0,0,.84l3.24,7.17a.63.63,0,0,0,.21.24l0,0c.66.38,13.47,7.79,14.33,8.3A.58.58,0,0,1,159.61,177.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6,131.65l0,0a1.19,1.19,0,0,0-.45-.11l-6.12-.35a1,1,0,0,1-1-1c.09-1,.14-1.93.14-2.86a27.56,27.56,0,0,0-.13-3,3,3,0,0,1,.67-1.81l6.83-8.27a1.88,1.88,0,0,0,.42-1.7l-3.25-7.17a.45.45,0,0,0-.2-.23l0,0a1,1,0,0,0-1,.33l-7.3,6.66a1.29,1.29,0,0,1-1.59.27,11.39,11.39,0,0,0-3.12-1.82,1.16,1.16,0,0,1-.73-1.28L205.88,99a.63.63,0,0,0-.31-.72,1.21,1.21,0,0,0-.68-.12l-7.13.71A1.93,1.93,0,0,0,196.2,100l-3.87,10.37a3.35,3.35,0,0,1-1.56,1.5,32.17,32.17,0,0,0-4.42,2.56c-.6.4-1.27.43-1.53,0l-3.64-5.58c-.27-.39-.85-.31-1.32.18L172,117.34a2.06,2.06,0,0,0-.6,1.72l2.18,7.39a2.51,2.51,0,0,1-.4,1.77,59.33,59.33,0,0,0-3.6,6.25,2.86,2.86,0,0,1-1.7,1.27l-6.71,1.62a2.22,2.22,0,0,0-1.51,1.26L156.31,150c-.17.53.21,1,.83,1l6.12.34a1,1,0,0,1,1,1,32.31,32.31,0,0,0,0,5.9,2.85,2.85,0,0,1-.67,1.8l-6.82,8.28a1.85,1.85,0,0,0-.42,1.7l3.24,7.17a.54.54,0,0,0,.2.22h0a.54.54,0,0,0,.25.06h0a1.31,1.31,0,0,0,.8-.37l7.29-6.67a1.29,1.29,0,0,1,1.59-.27A11.25,11.25,0,0,0,172.9,172a1.16,1.16,0,0,1,.73,1.28l-2.25,10.22a.64.64,0,0,0,.3.7h0a1.08,1.08,0,0,0,.67.12l7.13-.71a2,2,0,0,0,1.56-1.08l3.88-10.37a3.27,3.27,0,0,1,1.56-1.51c.74-.36,1.5-.76,2.26-1.2s1.43-.87,2.15-1.36,1.27-.43,1.53,0l3.65,5.58a.46.46,0,0,0,.18.16c.29.19.75.06,1.13-.34l7.84-8.28a2.06,2.06,0,0,0,.6-1.71l-2.18-7.38a2.56,2.56,0,0,1,.4-1.78,59.46,59.46,0,0,0,3.6-6.26,2.85,2.85,0,0,1,1.71-1.26l6.69-1.62a2.15,2.15,0,0,0,1.52-1.26L221,132.55A.75.75,0,0,0,220.6,131.65Zm-35.76,27.74-.4.1-.28.07-.64.1a6,6,0,0,1-.73.07l-.46,0h-.21a7.16,7.16,0,0,1-6.72-4.52,12,12,0,0,1-1-3.74,15.56,15.56,0,0,1-.12-2.07c0-6.47,3.37-14.49,8.85-20.28a24.44,24.44,0,0,1,5.41-4.38,16.88,16.88,0,0,1,1.79-.92,11.45,11.45,0,0,1,5.06-1.07h.31l.26,0a2.4,2.4,0,0,1,.28,0,7.18,7.18,0,0,1,5.61,4.44c3,6.69-.45,18.37-7.76,26.09A20.36,20.36,0,0,1,184.84,159.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,130.59l-3.76-2.18h0l0,0h0c-1.67-1-4-.81-6.5.66-5.12,2.95-9.26,10.13-9.26,16,0,2.94,1,5,2.7,6h0l3.43,2,.82-1.37a9.82,9.82,0,0,0,2.65-1c5.12-3,9.26-10.14,9.26-16a10.12,10.12,0,0,0-.29-2.37Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,145.1c0,2.94,1,5,2.7,6h0l3.43,2,.82-1.37a9.55,9.55,0,0,0,2.65-1,19.12,19.12,0,0,0,6.89-7.53l-13.42-7.75A19.25,19.25,0,0,0,176.34,145.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,130.59l-3.76-2.18h0l0,0h0c-1.67-1-4-.81-6.51.66a18.53,18.53,0,0,0-6.17,6.3l13.42,7.75a18.45,18.45,0,0,0,2.37-8.5,9.61,9.61,0,0,0-.29-2.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,131.11c-5.12,3-9.26,10.14-9.26,16s4.14,8.3,9.26,5.35,9.25-10.14,9.26-16S194.29,128.16,189.18,131.11Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-list--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-20",
    d: "M193.76,133.74a1.33,1.33,0,0,0-1.75.62l-4.77,11L186,144.25a1.45,1.45,0,0,0-1.91,0,1.18,1.18,0,0,0,.08,1.76l2.7,2.42a1.46,1.46,0,0,0,.95.38,1.23,1.23,0,0,0,.27,0,1.21,1.21,0,0,0,.95-.7l5.48-12.67A1.27,1.27,0,0,0,193.76,133.74Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.62,314.4a19.74,19.74,0,0,1,2.17.83,2.14,2.14,0,0,0,2.47-.51c.57-.89-.1-2-.75-2.88-3.5-4.53-7.09-9.46-7.46-15.17A8.92,8.92,0,0,1,57.11,300a10,10,0,0,0,2.23,2.76,3.46,3.46,0,0,0,3.35.64.65.65,0,0,0,.35-.28.74.74,0,0,0,0-.56c-1.32-3.55-3.12-7-4.66-10.43a24.81,24.81,0,0,0-1.8-3.52c-1.55-2.39-4.59-5-5.21-7.82-.17-.79-.54-2.6-.54-2.6s-3.41.2-4.84.47a36.09,36.09,0,0,0-6.49,1.93c-.66.28-1.61.37-1.79,1.2a2.93,2.93,0,0,0,.14,1.37c1,3.67,1.91,7.35,2.59,11.09,1,5.44,1.67,10.5,5,15a7.74,7.74,0,0,0,4.32,3.1,8.73,8.73,0,0,1,2,.51,11.39,11.39,0,0,1,1.27.92,4,4,0,0,0,2.38.67,17.18,17.18,0,0,1,1.89-.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.51,202.34c-5.94,1.4-9.24,6.12-11.17,15.11s-4.46,23-5.58,28.33c-1.43,6.77-.61,7.31.91,13.7s7.92,25.18,7.92,25.18,10.84-.17,14.1-3.67c0-.46-6.48-30.49-6.48-30.49l5.57-26.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.36,405.3c1.5-3.14,2-8.93,1.91-19.46l15.52,5.27s-3.29,15.37-3.51,18.78C51.71,418.64,38.36,405.3,38.36,405.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.41,410.5c-.18-.34-.69-1.08-.64-1.26A7.43,7.43,0,0,1,36,405.92a19.84,19.84,0,0,0,2.34-3.06c.4-.56.66-1.21,1.27-1.46,1.06-.43,4.52.2,6.61,1.3,3.42,1.8,4.46,4,4.27,6.31-.15,1.79-.51,2.92.34,2.67s1.46-1.78,1.46-1.79a11.88,11.88,0,0,0,.1,1.74,23.61,23.61,0,0,0,.1,4.45c.44,3,1.51,6.23,4,8.19,2,1.57,4.64,2.09,6.93,3.21A4.21,4.21,0,0,1,65,428.69a3.25,3.25,0,0,1-.12,3.56,6.23,6.23,0,0,1-2.76,2.29,13,13,0,0,1-4.18.14,37,37,0,0,1-8.62-1.3,13.4,13.4,0,0,1-4.93-2.28,11.73,11.73,0,0,1-3.26-4.64c-.74-1.76-1.25-3.61-1.88-5.41a60,60,0,0,0-3.16-7.15,31.44,31.44,0,0,1-1.65-3.28A.66.66,0,0,0,34.41,410.5Z",
    style: {
      fill: "#455a64"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.39,425.26a14.18,14.18,0,0,0,.61,2.41A7,7,0,0,0,41.26,431a16.25,16.25,0,0,0,2.35,1.52,26.23,26.23,0,0,0,7.34,2.3,31.73,31.73,0,0,0,5.84.46,17.77,17.77,0,0,1-6.52-3.73,11.72,11.72,0,0,1-2.47-2.92c-.16-.27-.31-.54-.45-.82-1.31-2.58-1.82-5.46-2.64-8.21a19.15,19.15,0,0,0-1.59-3.93,14.86,14.86,0,0,0-2.76-3.22c-4.3-4.17-7.41-2.48-7.44-2.46-.55.28-.41,2-.09,2.73a16.73,16.73,0,0,0,1.94,3.25c.5.7,1,1.43,1.42,2.16a11.89,11.89,0,0,1,1.65,3.49,23.33,23.33,0,0,1,.39,2.64C38.28,424.57,38.33,424.92,38.39,425.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,431.06a3.68,3.68,0,0,1-.58,1.1,6,6,0,0,1-3.12,1.63,15.06,15.06,0,0,1-7.42-.56,11.74,11.74,0,0,1-5.9-4.47,15.47,15.47,0,0,1-1.81-4.12,27.49,27.49,0,0,1-1-3.72,18,18,0,0,0-2.4-7.29c-2.26-3.47-5.86-5.16-8.65-4.91A2.69,2.69,0,0,0,32.92,410s2.8-.92,7.15,2.69a11.12,11.12,0,0,1,3.41,5.17c1.31,4,1.48,8.18,3.8,11.83a11.55,11.55,0,0,0,3.89,3.91A15,15,0,0,0,62,434.82c1.37-.31,3.45-1.53,3.44-2.23C65.46,432.25,65.46,431.39,65.41,431.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,271c-1.17,7.51-3.28,13.55-2,32.32.58,8.26,1.86,43.41,1.86,43.41a99.74,99.74,0,0,0-3.82,23c-.48,13-.62,25.7-.62,25.7a14.57,14.57,0,0,0,5.89,4,17.25,17.25,0,0,0,8.61.88s6.46-19.24,10.35-31c3.24-9.78,4.58-13.21,6.08-26.86,1.85-16.75,4.87-40.29,4.87-40.29L84.92,271Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,310.32c5.1,4.5,6.19,8.24,6.47,10.94S70.09,347.9,70.09,348c.23-1.64.46-3.48.69-5.58,1.85-16.74,4.86-40.26,4.87-40.29h0L84.92,271H55.57l2.48,17.88C57.3,296.52,59.84,305.82,64.94,310.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,399.08c-.37,1.62-.81,2.84.69,4.78s4.72,3,7.93,2.88a10,10,0,0,0,6.21-2.54c1.86-1.44,3.16-2.69,3.85-3.28s3.46-1.36,6.08-1.89,8.07-1.7,10.77-5.65a11.44,11.44,0,0,0,2.23-7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.22,383.49c-5.65,1.94-14.23,3.13-19.35,4.48-1.53,1.43-1.2,7.92-1.22,12.29,2,4.5,8.23,5.65,12.38,3.85,2.16-1.18,3.59-2.86,5.71-4.16a17,17,0,0,1,5.45-1.9,50.12,50.12,0,0,0,6.51-2c5.55-2.54,8.31-7.27,8-11.1C135.26,380.12,130.8,379.16,118.22,383.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,383.49c0,.18.3,7.48.3,7.48s.46,1.81,5.49,2.45,9.19-1.47,10.15-2.81c0,0,.14-2.57.43-5.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.57,284.59c.55,8.64,4.22,19.82,16.69,28.25,5.68,4.4,9.81,8.83,14.52,13.49,5.83,5.77,11.16,11.41,11.16,11.41s-2.58,6.64-2,18.37,2.65,30.31,2.65,30.31A14,14,0,0,0,107.9,389c5.46-.53,7.43-2.58,7.43-2.58s5.88-43.1,6.61-50.25,1.3-11.75-3.21-20.25C114,306.91,98.28,274,97.66,271H55.57Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.25,200.7c1.89-1.6,2.94-6.63,2-9.36s-4.8-9.24-5.32-17.08,10-19.89,19.14-18.94,13.94,6,16.39,12.78c1.5,4.14,0,5,.54,7.34,1.14,4.69,2.82,8.32.64,17.29-.8,3.28-3.58,4.55-6.19,5.18a18.78,18.78,0,0,1-5.89.2,56.83,56.83,0,0,0,0,6.09,2.79,2.79,0,0,0,2.63,2.7S54.36,202.3,56.25,200.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.85,187.86a2.8,2.8,0,1,1-5.38-1.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,189.81a4,4,0,0,0-3.37-2.55,2.79,2.79,0,0,0,2,2.52A2.73,2.73,0,0,0,80.75,189.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,177.17a1.46,1.46,0,1,1-1.84-1A1.48,1.48,0,0,1,77,177.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.92,171.74,73.6,173a1.87,1.87,0,0,1,1.07-2.36A1.73,1.73,0,0,1,76.92,171.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,173l-3.33-1.3a1.72,1.72,0,0,1,2.26-1.06A1.88,1.88,0,0,1,88.18,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,176.48a1.35,1.35,0,0,1-1.34,1.37,1.39,1.39,0,0,1,0-2.77A1.36,1.36,0,0,1,87.07,176.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.44,183l-5.19,2.32-1.64-10.18C83.54,174.45,86,179.13,88.44,183Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,198.11s-4.92-.74-6.31-1.54c-3.78-2.15-5.16-3.82-6-6.19a10.06,10.06,0,0,0,5.56,7.53,33.16,33.16,0,0,0,6.64,2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,186c.06,1.45-.21,3.94-1.71,5s-2.36,1.62-3.77,1.24c-.47-1.32-1.95-4.7-3.38-7.58s-7.81-13.7-1.71-17.82c-1.34-4.4.78-8.83,4.64-11.54,3.25-2.29,10.86-2.41,16-1.59,12.16,1.92,14.09-1.43,15.81-.58s.52,5.05-.86,6.28c1.9-.4,3.3.59,2.33,2.94s-3.57,4-7.91,4.65A29.75,29.75,0,0,1,68,165.46a24.61,24.61,0,0,1,1.66,5.28,5.53,5.53,0,0,1-1.37,4.54c-.93.88.4,3.22.2,4.21s-1.39,2.92-3.2-.83-5.71-3.84-7.3-2-1.52,3.82,0,7.18C59.19,186.53,62.23,187.6,64,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.21,202.87c7.55-1.57,19.9.37,31.1,5.8,5.28,2.56,9.2,4,12.58,5.88s5,8.81,5.32,14.13c.93,13.58.15,20.87,0,29.66-.23,13.1.73,16.64.73,16.64s-16.48,12.17-41.46,4.62c-12.12-3.67-11.65-9.77-11.7-14.08s.44-19.3-2.39-31.56S39.05,204.78,48.21,202.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.38,209.26c-4.13-3.73-2.88-3.93-5.57-6.13-3.33-2.75-17.94-6.16-19.12-5a15.93,15.93,0,0,1-4.31,3.19s.7,2.25,9.52,4.38C71.31,207.77,74.63,207.48,82.38,209.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.66,199.93c4.59.77,14.07,3.8,18.43,5s10.32,5.14,10.32,5.14,8.37,3.64,9.4,4.79,3.13,6.42,4,17.88c.49,6.67-.24,21.39,1.13,33.09a58.76,58.76,0,0,0,4.26,15.58s-2.41,5.71-4.73,6.1l-5.68-8.58L96,289.11s-10.35,8.52-34.53,3.37c-13.17-2.81-19-11.24-19-11.24s2-27.63,1.44-32.34-4.66-24.54-4.2-32.33,1.73-13.51,6.54-14.23A41,41,0,0,0,55.66,199.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.62,203.11c1.19.47,2.42.83,3.65,1.18s2.45.72,3.68,1.05c2.47.67,4.93,1.34,7.4,1.95s5,1.1,7.49,1.53l7.57,1.24c-2.56-.12-5.11-.37-7.65-.69A61.14,61.14,0,0,1,69.18,208c-2.49-.64-5-1.33-7.39-2.13A49.1,49.1,0,0,1,54.62,203.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,219c1,5.16,1.88,10.37,2.43,15.61a101.93,101.93,0,0,1,.51,15.82l-.89,15.78-.5,7.88L60.35,282l.22-7.9.31-7.89.72-15.78a110.16,110.16,0,0,0-.34-15.73c-.21-2.62-.49-5.24-.82-7.85S59.75,221.62,59.38,219Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,227.57c4.6-1.24,7.64-1.91,10.4-2.9A25.64,25.64,0,0,0,161,222c1.46-.88,4.36-4,6.83-4.33a52.43,52.43,0,0,1,5.51-.33s7.77-3.35,10-4.28,3.88-.78,4.15-.07c.52,1.31-.6,2.28-2.41,3.3S178.6,220,178.6,220s.88,2.22.26,3.62.34,2.78-.39,4.31.06,2.3-.78,4-1.43,2.31-6.17,3.15-4.31.07-8.66,1.58-14.49,5.23-14.49,5.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,213.26c4.71,2.24,8.28,4.16,14.76,7.9s18.74,10.54,18.74,10.54l28.45-7s3.68,2,5.32,4.9a13,13,0,0,1,1.25,9.75S136.59,249,131.12,250.8c-3.58,1.2-5.56,2.53-14.8-.75-10.47-3.72-23.78-9.16-23.78-9.16s-6-7.39-6.8-15S91.23,213.26,91.23,213.26Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.11,98.82A29.65,29.65,0,0,0,50,119.14l2.45,2.35A29.67,29.67,0,0,0,94.53,79.9l-2.34-2.47A29.67,29.67,0,0,0,42.11,98.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,98.81A32.24,32.24,0,0,0,66.27,130.7l3.57,9.35a1.87,1.87,0,0,0,3.49,0L77,130.76A32.21,32.21,0,1,0,39.6,98.81ZM72,69.29a29.53,29.53,0,0,1,20.23,8.14l2.34,2.47a29.67,29.67,0,0,1-42.05,41.59L50,119.14A29.67,29.67,0,0,1,72,69.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,69.29a29.53,29.53,0,0,1,20.23,8.14l2.34,2.47a29.67,29.67,0,0,1-42.05,41.59L50,119.14A29.67,29.67,0,0,1,72,69.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.32,82.87l1.45,14.45a11.08,11.08,0,0,0,22,0l1.47-14.45ZM72.84,99.36v1.49H71V99.36a3.39,3.39,0,0,1-3.24-2.71L70,96.07a1.81,1.81,0,0,0,2,1.51c.89,0,1.5-.38,1.5-1.17,0-1.17-1.33-1.28-2.75-1.64s-2.81-1-2.81-3c0-1.71,1.1-2.74,2.92-3V87.32h1.87v1.52a3.33,3.33,0,0,1,3.09,2.47l-2.14.56c-.18-.8-.76-1.29-1.89-1.29s-1.53.49-1.53,1.11c0,.92.81,1.12,2.24,1.47s3.43.86,3.43,3.13C75.88,98.08,74.66,99.1,72.84,99.36Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,106.92a3.75,3.75,0,0,0-3.75,3.76h7.5A3.75,3.75,0,0,0,71.8,106.92Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,113.6H65.63a.87.87,0,0,1-.88-.87h0a.88.88,0,0,1,.88-.88H78a.88.88,0,0,1,.87.88h0A.87.87,0,0,1,78,113.6Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,114.78H63.55a2.87,2.87,0,0,0-2.87,2.87H82.93A2.88,2.88,0,0,0,80.06,114.78Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.38,102.84h-.56a8.48,8.48,0,0,1-8.16-6.24l-1.89-6.92a2.86,2.86,0,0,1,.48-2.48,2.8,2.8,0,0,1,2.27-1.12h4.95l.25,2.46h-5.2a.43.43,0,0,0-.31.15.39.39,0,0,0-.06.34L55,96a6,6,0,0,0,5.19,4.37A12.17,12.17,0,0,0,61.38,102.84Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23,102.84h.56A8.48,8.48,0,0,0,91,96.6l1.89-6.92a2.86,2.86,0,0,0-.48-2.48,2.82,2.82,0,0,0-2.27-1.12h-5l-.26,2.46h5.21a.41.41,0,0,1,.3.15.39.39,0,0,1,.07.34L88.57,96a6,6,0,0,1-5.19,4.37A12.72,12.72,0,0,1,82.23,102.84Z",
    style: {
      fill: "#092166"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPlanning);
export default __webpack_public_path__ + "static/media/p_planning.91275d5dc7e3d05a8d4d0e69bd4aa55d.svg";
export { ForwardRef as ReactComponent };